import React from 'react';
import classnames from 'classnames';
import us from 'us';

var AK = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 137.7"
  }, React.createElement("polygon", {
    points: "31.1 134.26 31.05 133.84 31.37 133.79 31.35 134.19 31.1 134.26"
  }), React.createElement("polygon", {
    points: "31.94 133.88 31.89 133.75 32.19 133.28 32.38 133.71 31.94 133.88"
  }), React.createElement("polygon", {
    points: "22.7 127.3 24.26 130.01 25.04 130.58 23.96 130.26 22.7 127.3"
  }), React.createElement("polygon", {
    points: "20.91 124.89 21.31 125.2 21.44 125.66 21.2 125.55 20.91 124.89"
  }), React.createElement("polygon", {
    points: "34.16 131.09 33.82 130.65 34.16 130.37 34.4 130.64 34.16 131.09"
  }), React.createElement("polygon", {
    points: "45.35 134.53 45.65 135.09 45.13 135.37 45.07 134.32 45.75 134.51 45.35 134.53"
  }), React.createElement("polygon", {
    points: "46.45 134.83 46.73 134.87 46.95 135.31 46.14 135.31 46.45 134.83"
  }), React.createElement("polygon", {
    points: "47.03 134.66 47.27 134.69 47.21 135.06 46.6 134.58 47.03 134.66"
  }), React.createElement("polygon", {
    points: "38.59 131.96 39.62 132.3 37.55 133.68 36.98 131.15 38.59 131.96"
  }), React.createElement("polygon", {
    points: "41.51 134.04 38.89 133.72 38.82 133.3 41.87 132.48 41.51 134.04"
  }), React.createElement("polygon", {
    points: "48.66 134.55 48.84 134.73 48.37 134.74 48.59 134.52 48.66 134.55"
  }), React.createElement("polygon", {
    points: "44.73 133.3 44.77 135.12 41.9 135.32 43.7 133.07 44.73 133.3"
  }), React.createElement("polygon", {
    points: "47.95 134.14 48.25 134.3 47.88 134.32 47.55 134.17 47.95 134.14"
  }), React.createElement("polygon", {
    points: "22.47 125.03 22.27 124.53 22.69 124.3 22.93 124.75 22.47 125.03"
  }), React.createElement("polygon", {
    points: "27.46 127.33 26.8 126.73 27.78 126.14 28.22 126.89 27.46 127.33"
  }), React.createElement("polygon", {
    points: "47.49 133.67 47.1 134.1 46.66 133.16 47.35 133 47.49 133.67"
  }), React.createElement("polygon", {
    points: "18.51 122.47 16.87 123.11 16.65 122.44 19.14 121.55 18.51 122.47"
  }), React.createElement("polygon", {
    points: "58.81 136.36 59.77 137.15 61.61 137.7 58.99 137.47 56.59 135.9 58.81 136.36"
  }), React.createElement("polygon", {
    points: "12.66 116.67 12.39 116.5 12.42 116.26 12.82 116.63 12.66 116.67"
  }), React.createElement("polygon", {
    points: "64.68 136.92 63.93 137.07 63.48 136.85 64.66 136.08 64.68 136.92"
  }), React.createElement("polygon", {
    points: "56.93 133.77 56.39 135.93 53.32 135.74 50.45 134.81 56.93 133.77"
  }), React.createElement("polygon", {
    points: "3.93 110.88 3.22 111.74 1.88 110.65 3.23 110.52 3.93 110.88"
  }), React.createElement("polygon", {
    points: "70.41 137.15 70 137.03 70.39 136.61 70.55 136.9 70.41 137.15"
  }), React.createElement("polygon", {
    points: "73.59 136.78 72.53 137.08 72.36 136.97 73.43 136.03 73.59 136.78"
  }), React.createElement("polygon", {
    points: "6.3 110.19 6.32 110.33 5.93 110.03 6.16 109.94 6.3 110.19"
  }), React.createElement("polygon", {
    points: "75.97 136.46 75.67 136.38 75.9 135.94 76.37 136.29 75.97 136.46"
  }), React.createElement("polygon", {
    points: "77.87 135.6 77.93 136.56 76.72 135.98 76.93 135.66 77.87 135.6"
  }), React.createElement("polygon", {
    points: "76.68 135.53 76.35 135.4 76.36 135.09 76.92 135.26 76.68 135.53"
  }), React.createElement("polygon", {
    points: "2.05 105.47 3 106.08 3.65 107.77 0 105 2.05 105.47"
  }), React.createElement("polygon", {
    points: "78.27 135.23 78.25 134.63 78.54 134.61 78.61 134.91 78.27 135.23"
  }), React.createElement("polygon", {
    points: "87.16 132.31 87.58 133.87 82.59 136.53 80.84 136.85 87.16 132.31"
  }), React.createElement("polygon", {
    points: "96.31 131.95 95.74 132.39 95.55 132.89 95.32 132.16 96.31 131.95"
  }), React.createElement("polygon", {
    points: "96.36 131.08 96.01 130.95 96.06 130.76 96.5 130.93 96.36 131.08"
  }), React.createElement("polygon", {
    points: "90.89 133.82 93.32 132.37 92.2 130.27 95.7 130.87 92.71 134.39 87.46 134.45 90.89 133.82"
  }), React.createElement("polygon", {
    points: "100.41 130.84 100.18 131.07 99.36 130.66 99.87 130.64 100.41 130.84"
  }), React.createElement("polygon", {
    points: "101.9 130.72 101.66 131.07 100.56 130.76 101.03 130.51 101.9 130.72"
  }), React.createElement("polygon", {
    points: "97.73 129.6 98.51 130.34 96.79 130.52 96.81 129.39 97.73 129.6"
  }), React.createElement("polygon", {
    points: "99.47 129.16 99.88 129.84 98.94 130.32 98.72 129.19 99.47 129.16"
  }), React.createElement("polygon", {
    points: "113.66 130.35 113.5 130.48 113.34 130.08 113.66 130.23 113.66 130.35"
  }), React.createElement("polygon", {
    points: "112.75 129.73 112.61 130.36 111.86 129.24 112.02 129.27 112.75 129.73"
  }), React.createElement("polygon", {
    points: "126.94 128.86 126.66 128.83 126.66 128.36 127.01 128.65 126.94 128.86"
  }), React.createElement("polygon", {
    points: "245.79 113.47 246.35 113.51 246.69 114.48 245.78 113.95 245.79 113.47"
  }), React.createElement("polygon", {
    points: "128.14 127.53 128.47 127.73 128.09 128.07 127.89 127.57 128.14 127.53"
  }), React.createElement("polygon", {
    points: "114.68 126.85 114.05 126.18 114.88 125.8 114.97 126.35 114.68 126.85"
  }), React.createElement("polygon", {
    points: "252 110.89 251.92 111.86 251.11 111.61 251.85 110.76 252 110.89"
  }), React.createElement("polygon", {
    points: "108.32 124.34 109.33 124.62 109.79 126.79 110.73 126.97 111.03 127.85 102.77 128.6 104.63 125.14 108.32 124.34"
  }), React.createElement("polygon", {
    points: "127.89 126.76 127.92 127.25 127.35 127.41 127.42 126.51 127.89 126.76"
  }), React.createElement("polygon", {
    points: "117.41 124.76 117.77 125.12 117.14 125.52 116.62 124.71 117.41 124.76"
  }), React.createElement("polygon", {
    points: "244.93 111.68 245.76 112.41 245.54 112.93 244.92 112.8 244.93 111.68"
  }), React.createElement("polygon", {
    points: "119.13 124.48 119.2 124.79 119.13 124.94 118.73 124.62 119.13 124.48"
  }), React.createElement("polygon", {
    points: "127.18 126.06 126.58 126.61 127.23 125.03 127.29 125.66 127.18 126.06"
  }), React.createElement("polygon", {
    points: "243.76 111.97 243.88 112.69 246.66 115.18 243.95 113.79 243.76 111.97"
  }), React.createElement("polygon", {
    points: "118.19 124.48 117.85 124.55 117.63 124.38 118.25 124.12 118.19 124.48"
  }), React.createElement("polygon", {
    points: "251.15 109.97 250.43 111.25 249.91 109.13 250.85 109.41 251.15 109.97"
  }), React.createElement("polygon", {
    points: "125.48 125.11 125.76 125.83 123.89 127.68 124.2 125.78 125.48 125.11"
  }), React.createElement("polygon", {
    points: "242.49 111.28 242.92 111.95 242.19 112.34 241.88 111.51 242.49 111.28"
  }), React.createElement("polygon", {
    points: "125.06 124.35 124.88 124.38 124.73 124.16 124.93 124.1 125.06 124.35"
  }), React.createElement("polygon", {
    points: "123.75 123.93 123.66 124.73 122.86 124.05 123.07 123.86 123.75 123.93"
  }), React.createElement("polygon", {
    points: "122.14 124.12 123.06 125.14 121.42 125.52 121.99 123.33 122.14 124.12"
  }), React.createElement("polygon", {
    points: "248.43 108.51 249.49 109.09 249.54 110.39 248.99 110.1 248.43 108.51"
  }), React.createElement("polygon", {
    points: "241.03 110.88 241.68 111.03 241.32 112.33 240.8 111.88 241.03 110.88"
  }), React.createElement("polygon", {
    points: "111.43 122.08 111.19 121.98 111.45 121.79 111.49 121.94 111.43 122.08"
  }), React.createElement("polygon", {
    points: "124.25 123.21 124.59 123.25 124.54 123.78 123.76 123.52 124.25 123.21"
  }), React.createElement("polygon", {
    points: "241.34 110.74 240.85 110.75 241.07 110.06 241.56 110.29 241.34 110.74"
  }), React.createElement("polygon", {
    points: "241.92 110.27 241.37 109.93 241.39 109.71 242.04 109.69 241.92 110.27"
  }), React.createElement("polygon", {
    points: "240.43 110.11 240.69 110.74 240.01 111.01 240.1 110.13 240.43 110.11"
  }), React.createElement("polygon", {
    points: "128.63 121.1 128.32 120.93 128.47 120.74 128.56 120.75 128.63 121.1"
  }), React.createElement("polygon", {
    points: "240.04 108.02 240.09 107.85 241.26 107.75 240.51 108.83 240.04 108.02"
  }), React.createElement("polygon", {
    points: "131.07 120.53 131.21 120.8 130.38 120.89 130.61 120.28 131.07 120.53"
  }), React.createElement("polygon", {
    points: "241.27 107.18 241.47 107.12 241.54 107.84 241.02 107.5 241.27 107.18"
  }), React.createElement("polygon", {
    points: "237.04 108.06 237.64 107.88 237.22 108.85 236.64 108.27 237.04 108.06"
  }), React.createElement("polygon", {
    points: "145.02 121.69 144.21 121.43 144.92 120.68 145.04 120.8 145.02 121.69"
  }), React.createElement("polygon", {
    points: "238.85 107.95 238.41 107.86 238.62 107.4 238.81 107.68 238.85 107.95"
  }), React.createElement("polygon", {
    points: "249.59 103.7 251.52 105.52 251.65 109.26 249.78 106.12 249.95 108.92 248.3 108.14 249.59 103.7"
  }), React.createElement("polygon", {
    points: "140.17 119.65 140.09 119.9 139.88 119.69 140.08 119.45 140.17 119.65"
  }), React.createElement("polygon", {
    points: "240.03 105.16 240.75 106.27 239.07 107.43 239.17 105.68 240.03 105.16"
  }), React.createElement("polygon", {
    points: "139.79 118.76 139.65 118.55 139.8 118.19 139.83 118.57 139.79 118.76"
  }), React.createElement("polygon", {
    points: "243.7 103.68 245.53 103.78 245.81 105.16 242.98 104.56 243.66 102.41 243.7 103.68"
  }), React.createElement("polygon", {
    points: "238.77 103.99 246.8 108.38 244.95 107.95 244.7 109.43 248.14 109.91 249.48 114.09 245.37 110.85 242.89 111.47 243.32 108.43 241.35 109.09 241.76 106.94 240.46 104.97 239 105.08 238.77 103.99"
  }), React.createElement("polygon", {
    points: "135.31 117.25 135.05 117.11 135 117 135.38 116.96 135.31 117.25"
  }), React.createElement("polygon", {
    points: "242.44 102.06 242.53 103.6 240.98 103.34 241.25 102.37 242.44 102.06"
  }), React.createElement("polygon", {
    points: "244.67 102.05 245.94 102.78 245.64 103.63 243.41 101.36 244.67 102.05"
  }), React.createElement("polygon", {
    points: "152.31 116.03 152 116.27 151.26 116.22 151.77 115.87 152.31 116.03"
  }), React.createElement("polygon", {
    points: "138.7 115.36 138.99 115.77 137.52 115.75 137.85 115.31 138.7 115.36"
  }), React.createElement("polygon", {
    points: "149.87 115.47 150.1 115.68 150.09 115.93 148.53 117.06 149.87 115.47"
  }), React.createElement("polygon", {
    points: "151.5 115.47 151.03 116.24 150.41 116.14 150.65 115.53 151.5 115.47"
  }), React.createElement("polygon", {
    points: "84.88 107.39 85.79 107.64 85.95 107.86 85.2 108.07 84.88 107.39"
  }), React.createElement("polygon", {
    points: "240.57 99.72 242.49 100.74 241.69 101.86 240.97 101.77 240.57 99.72"
  }), React.createElement("polygon", {
    points: "235.93 100.68 237.69 102.27 237.41 107.33 234.26 101.38 235.93 100.68"
  }), React.createElement("polygon", {
    points: "236.34 98.82 239.91 98.91 240.67 101.27 238.59 100.11 240.27 102.64 238.21 103.25 236.34 98.82"
  }), React.createElement("polygon", {
    points: "155.32 111 156.57 111.18 154.65 112.35 154.43 111.55 155.32 111"
  }), React.createElement("polygon", {
    points: "84.38 102.4 83.52 103.14 83.16 102.53 84.56 102.23 84.38 102.4"
  }), React.createElement("polygon", {
    points: "228.66 99.78 228.91 101.59 228.08 101.99 227.36 99.47 228.66 99.78"
  }), React.createElement("polygon", {
    points: "152.57 108.86 152.35 108.67 152.41 108.14 152.56 108.28 152.57 108.86"
  }), React.createElement("polygon", {
    points: "228.85 98.03 231.58 98.79 233.67 102.49 234.71 106.73 232.81 103.07 230.37 102.64 228.85 98.03"
  }), React.createElement("polygon", {
    points: "158.38 104.77 158.78 105.14 158.61 105.38 158.04 105.08 158.38 104.77"
  }), React.createElement("polygon", {
    points: "154.92 105.43 155.13 106.02 153.75 105.07 153.99 104.73 154.92 105.43"
  }), React.createElement("polygon", {
    points: "156.97 105.07 156.6 104.97 156.59 104.78 157.1 104.66 156.97 105.07"
  }), React.createElement("polygon", {
    points: "155.94 105.09 159.56 107.49 156.15 108.31 157.48 109.99 155.32 109.62 151.26 114.39 152.95 111.35 149.75 111.5 151.41 111.5 150.55 113.52 148.44 109.66 150.93 107.11 151.77 107.33 151.39 108.13 152.12 108.21 152.31 109.2 152.92 110.02 153.41 110.27 152.16 106.05 153.91 107.48 155.8 105.84 154.76 104.49 155.94 105.09"
  }), React.createElement("polygon", {
    points: "223.94 94.81 223.83 95.04 223.96 95.75 223.83 96.2 223.02 94.64 223.94 94.81"
  }), React.createElement("polygon", {
    points: "155.14 103.77 155.49 103.76 155.78 104.25 156.43 104.55 154.25 104.04 155.14 103.77"
  }), React.createElement("polygon", {
    points: "160.7 103.05 160.49 102.92 160.76 102.34 160.9 102.5 160.7 103.05"
  }), React.createElement("polygon", {
    points: "225.96 92.5 226.79 94.55 229.52 93.12 229.71 95.04 225.77 94.5 230.17 95.15 231 97.31 226.56 96.12 228.27 98.06 227.32 98.98 224.07 96.39 224.01 94.96 225.5 95.74 223.44 93.28 223.82 93.2 224.37 94.13 224.79 94.22 225.96 92.5"
  }), React.createElement("polygon", {
    points: "156.79 102.27 156.34 102.12 156.25 101.88 156.59 101.89 156.79 102.27"
  }), React.createElement("polygon", {
    points: "231.12 90.65 231.77 91.06 229.86 90.72 230.24 90.32 231.12 90.65"
  }), React.createElement("polygon", {
    points: "228.79 90.51 232.17 91.21 235.04 95.03 231.81 91.86 235.28 96.87 233.04 100.38 233.42 97.13 228.79 90.51"
  }), React.createElement("polygon", {
    points: "156.76 102.27 156.91 102.5 156.92 101.7 156.41 101.33 157.42 100.72 160.18 101.84 156.79 104.59 155.02 103.23 156.76 102.27"
  }), React.createElement("polygon", {
    points: "158.03 100.73 157.28 100.23 158.47 99.49 158.51 100.16 158.03 100.73"
  }), React.createElement("polygon", {
    points: "126.51 98.32 126.32 97.95 126.43 97.68 126.58 98.19 126.51 98.32"
  }), React.createElement("polygon", {
    points: "125.89 97.98 125.83 97.89 126 97.52 126.07 97.68 125.89 97.98"
  }), React.createElement("polygon", {
    points: "124.21 97.94 123.07 98.6 124.91 96.79 124.28 97.86 124.21 97.94"
  }), React.createElement("polygon", {
    points: "158.79 96.97 159.25 97.01 158.44 97.32 158.56 96.88 158.79 96.97"
  }), React.createElement("polygon", {
    points: "164.97 93.95 164.65 93.81 165.12 93.21 165.31 93.41 164.97 93.95"
  }), React.createElement("polygon", {
    points: "154.21 94.07 153.74 94.14 153.64 93.86 154.24 93.52 154.21 94.07"
  }), React.createElement("polygon", {
    points: "182.16 91.77 182.07 91.69 182.22 91.41 182.25 91.47 182.16 91.77"
  }), React.createElement("polygon", {
    points: "166.49 92.81 166.45 93.02 165.95 93.21 166.06 92.86 166.49 92.81"
  }), React.createElement("polygon", {
    points: "161.98 91.74 162.06 91.77 162 91.75 161.98 91.74"
  }), React.createElement("polygon", {
    points: "188.63 87.72 189.03 86.71 189.84 86 189.19 86.77 188.63 87.72"
  }), React.createElement("polygon", {
    points: "175.19 87.59 174.68 88.31 174.28 88.37 174.34 87.99 174.65 88.11 175.19 87.59"
  }), React.createElement("polygon", {
    points: "175.29 88.16 175.04 88.19 175.8 87.18 175.7 87.73 175.29 88.16"
  }), React.createElement("polygon", {
    points: "175.28 86.82 175.53 87.06 174.71 87.86 175.22 86.61 175.28 86.82"
  }), React.createElement("polygon", {
    points: "157.45 87.99 157.17 87.68 157.19 87.44 157.4 87.6 157.45 87.99"
  }), React.createElement("polygon", {
    points: "174.78 86.82 174.52 87.61 173.95 87.7 174.86 86.34 174.78 86.82"
  }), React.createElement("polygon", {
    points: "177.06 85.86 176.96 85.61 177.48 85.25 177.51 85.47 177.06 85.86"
  }), React.createElement("polygon", {
    points: "178.34 84.73 177.35 88.61 175.67 89.43 178.05 84.72 178.34 84.73"
  }), React.createElement("polygon", {
    points: "174.92 85.44 174.47 85.55 174.86 84.82 175.02 84.91 174.92 85.44"
  }), React.createElement("polygon", {
    points: "186 84.07 185.36 84.02 186 83.34 185.97 83.83 186 84.07"
  }), React.createElement("polygon", {
    points: "105.52 81.59 107.1 85.12 104.46 86.45 100.14 81.94 105.52 81.59"
  }), React.createElement("polygon", {
    points: "180.44 83.62 181.16 84 181.95 83.68 182.26 83.93 180.41 85.39 180.44 83.62"
  }), React.createElement("polygon", {
    points: "176.03 83.8 176.35 84.67 175.85 86.44 175.34 85.53 176.03 83.8"
  }), React.createElement("polygon", {
    points: "159.41 86.04 159.21 85.98 159.89 84.77 160.08 84.96 159.41 86.04"
  }), React.createElement("polygon", {
    points: "81.43 75.94 82.47 76.87 80.97 76.25 79.95 74.09 81.43 75.94"
  }), React.createElement("polygon", {
    points: "182.12 83.34 181.23 83.56 183.27 82.02 183.25 82.38 182.12 83.34"
  }), React.createElement("polygon", {
    points: "80.02 73.64 79.87 73.35 80.09 73.15 80.11 73.22 80.02 73.64"
  }), React.createElement("polygon", {
    points: "176.95 82.19 177.3 82.47 176.73 82.69 176.69 82.27 176.95 82.19"
  }), React.createElement("polygon", {
    points: "174.92 82.13 175.28 82.38 174.97 82.65 174.64 82.19 174.92 82.13"
  }), React.createElement("polygon", {
    points: "174.26 82.81 173.85 82.41 173.84 81.99 174.25 82.12 174.26 82.81"
  }), React.createElement("polygon", {
    points: "177.81 80.44 177.84 80.85 177.15 80.75 177.47 80.48 177.81 80.44"
  }), React.createElement("polygon", {
    points: "174.41 80.59 174.94 81.37 174.55 81.68 174.09 81.44 174.41 80.59"
  }), React.createElement("polygon", {
    points: "166.04 79.66 165.85 79.67 166.18 79.28 166.21 79.38 166.04 79.66"
  }), React.createElement("polygon", {
    points: "108.4 69.11 108.17 69.09 108.38 68.73 108.32 68.94 108.4 69.11"
  }), React.createElement("polygon", {
    points: "114.64 62.06 114.52 62.07 114.5 61.96 114.63 61.93 114.64 62.06"
  }), React.createElement("polygon", {
    points: "96.5 58.26 96.55 58.38 96.56 58.53 96.5 58.26"
  }), React.createElement("polygon", {
    points: "96.5 58.26 96.39 58.04 96.22 57.59 96.38 57.9 96.5 58.26"
  }), React.createElement("polygon", {
    points: "98.33 56.3 98.16 56.22 98.09 56.16 98.05 56.07 98.33 56.3"
  }), React.createElement("polygon", {
    points: "95 55.98 95.17 56.52 94.07 54.99 94.73 55.56 95 55.98"
  }), React.createElement("polygon", {
    points: "92.9 54.34 93.07 54.38 93.84 54.82 92.95 54.41 92.9 54.34"
  }), React.createElement("polygon", {
    points: "93.19 53.07 93.25 53.1 93.24 53.1 93.19 53.07"
  }), React.createElement("polygon", {
    points: "93.19 53.07 92.97 52.97 93.03 52.97 93.19 53.07"
  }), React.createElement("polygon", {
    points: "122.86 58.68 122.86 59.28 121.66 58.9 121.99 58.57 122.86 58.68"
  }), React.createElement("polygon", {
    points: "92.97 52.97 93.64 53.45 96 53.02 100.52 57.84 96.78 59.29 96.59 57.78 95.21 56.86 95.46 56.24 93.73 54.39 92.9 54.28 91.56 54.91 90.56 54.21 91.45 51.05 92.97 52.97"
  }), React.createElement("polygon", {
    points: "105.68 45.16 105.54 45.08 105.67 44.95 105.78 45.02 105.68 45.16"
  }), React.createElement("polygon", {
    points: "104.31 38.55 104.16 38.55 104.19 38.39 104.31 38.38 104.31 38.55"
  }), React.createElement("polygon", {
    points: "107.66 39.35 107.72 39.2 108 39.12 107.91 39.2 107.66 39.35"
  }), React.createElement("polygon", {
    points: "108.25 39.13 108 39.43 108.06 39.13 108.64 38.93 108.25 39.13"
  }), React.createElement("polygon", {
    points: "109.87 38.43 109.78 38.43 111.24 37.67 110.68 38.03 109.87 38.43"
  }), React.createElement("polygon", {
    points: "111.6 37.53 111.37 37.62 113.06 36.82 113.51 36.77 111.6 37.53"
  }), React.createElement("polygon", {
    points: "113.72 36.68 113.74 36.55 114.03 36.47 114.01 36.51 113.72 36.68"
  }), React.createElement("polygon", {
    points: "114.28 36.48 114.13 36.51 114.83 36.09 114.82 36.12 114.28 36.48"
  }), React.createElement("polygon", {
    points: "115.95 35.63 115.56 35.82 115.23 35.92 115.27 35.82 115.95 35.63"
  }), React.createElement("polygon", {
    points: "115.95 35.63 116.09 35.58 116.17 35.57 115.95 35.63"
  }), React.createElement("polygon", {
    points: "116.17 35.57 116.44 35.5 116.31 35.56 116.17 35.57"
  }), React.createElement("polygon", {
    points: "116.44 35.5 116.49 35.48 116.5 35.48 116.44 35.5"
  }), React.createElement("polygon", {
    points: "116.5 35.48 118.37 34.96 118.41 35.01 118 35.21 116.5 35.48"
  }), React.createElement("polygon", {
    points: "126.5 12.54 126.41 13.16 126.52 12.18 126.61 11.82 126.73 11.64 126.5 12.54"
  }), React.createElement("polygon", {
    points: "186.38 9.91 185.78 9.55 184.85 9.27 185.94 9.57 186.38 9.91"
  }), React.createElement("polygon", {
    points: "126.89 11.29 126.77 11.5 127.18 10.54 127.79 9.83 126.89 11.29"
  }), React.createElement("polygon", {
    points: "128.12 9.54 127.9 9.74 128.47 8.9 128.71 8.73 128.12 9.54"
  }), React.createElement("polygon", {
    points: "128.78 8.57 128.99 8.14 129.53 7.68 129.94 7.51 128.78 8.57"
  }), React.createElement("polygon", {
    points: "130.75 6.96 131.63 7.28 130.88 7.05 130.48 7.25 130.75 6.96"
  }), React.createElement("polygon", {
    points: "164.5 6.23 165.18 6.64 165.36 6.57 165.66 6.79 165.13 6.71 164.3 6.31 164.5 6.23"
  }), React.createElement("polygon", {
    points: "161.98 91.74 160.58 91.17 160.15 90.44 161.77 82.92 165.47 80.32 170.71 81.5 166.63 79.4 169.52 76.52 166.9 78.68 164.68 77.87 157.97 86.49 157.21 87.09 156.07 86.44 155.4 86.53 156.85 89.51 154.86 91.64 154 90.52 150.81 95.57 154.82 97.84 150.47 103.89 141.14 109.66 141.02 112.32 132.74 116.15 131.72 117.39 133.99 117.81 132.53 119.52 132.41 118.06 131.72 117.93 131.4 119.81 127.59 120.06 127.03 122.45 126.25 120.25 119.57 123.48 120.32 122.14 118.3 121.3 116.14 125.14 114.1 125.3 113.49 123.18 113.53 125.85 110.95 124.1 111.33 125.71 109.82 126.48 110.26 124.16 117.77 119.07 120.68 118.4 121.98 120.9 122.18 119.57 124.46 120.66 124.29 116.73 131.03 112.49 132.02 113.55 133.7 109.34 137.55 108.19 137.01 103.34 138.95 102.94 137.29 101.33 139.96 98.53 140.73 95.28 134.8 99.23 133.81 96.17 135.12 96.11 135.68 97.23 135.78 96.97 135.26 95.93 133.72 94.74 132.15 100.68 126.55 95.01 120.36 98.34 118.79 97.35 121.02 96.47 121.64 94.11 120.3 94.27 119.87 92.68 121.41 91.04 119.22 84.47 121.87 81.6 118.32 84.62 118.73 86.79 114.3 87.74 108.41 81.12 110.64 78.16 111.5 79.18 112.95 79.71 112.1 81.43 116.15 80.47 114.31 79.39 115.32 78.39 114.03 79.29 110.88 78.03 109.91 78.14 111.5 76.93 109.42 75.75 110.04 75.44 110.44 74.29 110.75 74.34 111.24 73.86 111.71 73.87 112.39 73.16 110.27 74.33 108.69 76.63 107.55 70.58 109.47 70.6 111.97 65.83 113.82 66.85 113.28 63.46 115.48 62.45 115.57 60.76 117.77 61.19 117.23 62.94 123.09 59.28 126.88 60.08 128.58 57.75 126.45 53.01 129.23 50.79 128.1 48.93 122.23 52.91 121.33 50.31 121.01 52.22 111.19 49.24 110.98 46.71 109.69 44.84 109.56 44.21 109.64 43.84 112.5 44.01 108.57 42.12 106.56 39.71 108.57 39.65 113.15 36.95 115.57 37.6 114.98 36.14 119.94 34.77 121.61 35.01 121.9 35.32 119.72 37.96 121.18 39.08 129.38 39.77 129.06 37.81 126.94 38.27 125.82 32.79 127.97 36.99 132.32 37.8 132.35 35.91 128.47 36.43 128.78 32.9 125.94 32.53 126.45 31.42 126.41 31.24 122.22 31.11 121.53 27.01 114.71 20.05 117.2 16.32 124.77 15.75 130.68 7.21 129.94 8.41 136.1 5.64 135.41 7.68 136.29 8.75 137.79 6.24 135.73 5.26 141.73 3.99 145.53 0 147.82 2.25 146.13 3.77 146.64 5.03 149.03 2.06 151.25 4.96 156.24 4.3 156.96 6.41 155.49 6.61 159.29 7.89 163.85 6.51 176.45 9.42 180.88 7.66 187.51 10.12 201.66 81.42 208.91 79.63 208.96 81.76 217.48 89.25 219.73 86.68 220.65 86.36 220.8 82.62 224.61 80.89 234.66 88.3 245.38 99.81 253.87 100.97 256 109.45 253.82 111.66 254.32 107.08 252.5 109.6 253.78 107.56 249.97 102.18 246.51 107.73 245.93 103.23 247.45 102.52 247.71 102.07 242.38 100.52 240.21 97.44 236.95 97.77 237.03 96.92 237.91 96.64 238.57 96.01 238.57 95.72 235.33 94 235.63 93.8 238.21 94.72 238.34 94.55 235.21 92.3 237.03 92.19 235.17 92.19 234.97 93.39 234.13 90.67 232.84 91.75 232.91 88.02 232.15 90.88 230.47 90.17 229.4 90.27 224.72 82.75 228.4 91.74 226.32 90.33 224.87 91.57 224.3 87.48 222.53 86.89 222.92 89.11 219.02 87.54 219.18 89.5 221.25 88.77 224.07 91.04 222.22 93.61 207.28 86.53 208 82.78 209.42 85.82 210.51 83.66 207.73 82.38 205.24 85.73 200.61 85.2 201.22 84.5 200.52 83.15 199.65 84.75 189.66 85.87 186.7 84.12 187.47 80.76 184.94 83.91 182.72 83.33 183.3 82.7 183.71 81.57 181.36 82.11 182.05 80.82 179.81 81.86 181.8 80.52 179.31 80.16 180.75 78.34 176.96 80.66 176.02 78.67 175.09 81.26 175.29 77.76 171.97 81.88 174 83 172.92 83.46 172.23 84.5 175.11 84.22 173.5 85.81 173.53 88.31 170.27 89.23 169.66 87.32 169.41 90.52 168.52 88.64 168.54 91.02 167.4 90.01 167.55 91.34 165.05 92.07 163.98 94.86 160.87 95.27 160.2 93.37 162.22 93.05 163.64 90.36 161.98 91.74"
  }));
});

var AL = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.43 256"
  }, React.createElement("polygon", {
    points: "16.24 254.82 6.01 255.03 15.44 253.13 16.24 254.82"
  }), React.createElement("polygon", {
    points: "33.37 0.52 130.98 2.52 149.44 112.02 153.97 127.1 160.19 138.76 159.14 143.93 163.43 147.53 157.41 152.84 152.41 171.39 157.15 186.78 154.6 205.65 158.44 210.74 159.01 215.37 39.94 214.89 38.37 222.06 48.37 232.63 46.6 239.31 48.82 244.42 42.14 251.06 38.57 249.04 38.81 251.97 40.72 251.6 36.5 254.79 19.04 256 31.43 253.24 28.9 246.51 24.74 245.96 23.45 242.22 24.86 236.86 20.23 228.67 14.69 250.44 6.54 246.25 1.97 246.87 0 166.51 21.57 6.39 17.49 0 33.37 0.52"
  }));
});

var AR = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 224.32"
  }, React.createElement("polygon", {
    points: "253.26 32.34 256 38.93 251.54 38.23 250.31 40.26 253.59 43.01 241.79 50.33 244.07 54.8 241.98 58.02 243.79 61.47 238.91 63.89 238.47 67.66 233.71 73.07 235.55 87.17 234.49 88.78 230.72 88.44 228.48 93.73 223.77 96.07 226.02 101.75 216.01 107.99 215.34 113.78 211.36 113.68 209.33 119.95 209.52 133.83 204.71 137.26 200.81 136.78 200.27 142.96 197.6 142.89 195.38 147.99 190.55 151.19 194.49 154.82 193.97 158.43 183.36 161.97 186.45 165.71 184.69 168.72 186 173.13 176.29 181.76 180.43 184.75 180.2 187.68 175.99 189.04 181.83 194.66 181.52 200.77 178.97 204.79 182.71 207.31 183.84 214.5 180.2 217.65 179.98 224.32 25.14 223.59 25.54 188.87 17.79 186.16 7.36 187.97 7.69 186.31 5.05 186.06 2.32 182.38 7.48 71.37 0 0 113.17 1.75 229.91 0.91 235.11 8.83 235.06 14.39 223.32 25.73 219.24 33.83 253.26 32.34"
  }));
});

var AZ = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.08 256"
  }, React.createElement("polygon", {
    points: "216.79 42.29 219.08 256 141.68 255.8 0 200.02 4.3 190.18 11.31 189.86 14.36 184.76 13.11 177.35 5.91 173.91 7.02 168.78 5.35 163.5 5.4 159.46 9.24 158.48 12.98 152.75 14.94 145.83 14.35 135.13 19.63 128.18 29.7 121 20.76 112.65 19.14 105.3 12.39 94.03 12.07 83.08 14.71 79.21 11.82 65.44 12.52 48.98 10.16 43.12 11.6 38.92 17.23 36.86 24.39 37.91 28.62 43.46 32.64 42.66 35.88 35.43 37.4 0 216.33 2.74 216.79 42.29"
  }));
});

var CA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.64 256"
  }, React.createElement("polygon", {
    points: "134.56 249.53 131.37 248.93 128.71 243.77 129.57 243.98 134.56 249.53"
  }), React.createElement("polygon", {
    points: "107.39 237.86 108.95 238.8 109.17 239.37 105.93 237.83 107.39 237.86"
  }), React.createElement("polygon", {
    points: "133.88 233.76 135.24 236.09 131.78 236.03 128.25 232.14 133.88 233.76"
  }), React.createElement("polygon", {
    points: "94.56 217.87 95.81 219.7 92.61 221.12 89.73 218.18 94.56 217.87"
  }), React.createElement("polygon", {
    points: "88.33 217.34 88.64 217.83 85.5 217.74 87.04 216.36 88.33 217.34"
  }), React.createElement("polygon", {
    points: "99.56 216.75 105.29 216.52 106.16 217.5 100.39 219.27 97.01 216.63 99.56 216.75"
  }), React.createElement("polygon", {
    points: "91.28 30.05 92.47 81.85 215.7 184.42 222.78 198.43 228.64 201.86 220.65 212.58 221.19 223.41 217.1 228.07 218.53 236.83 224.03 239.58 223.06 246.12 163.55 256 161.03 251.99 163.69 253.55 162.97 251.69 160.13 251.81 158.4 241.34 153.46 234.43 138.91 223.77 132.37 224.46 129.47 216.69 122.72 217.35 115.31 215.06 112 210.69 104.77 206.68 84.69 206.18 80.53 202.95 80.39 187.45 75.16 185.37 75.11 179.84 66.13 173.38 61.27 164.61 52.74 156.23 50.61 148.56 53.56 146.91 54.82 142.01 52.42 138.08 47.74 138.03 42.76 133.62 38.82 122.89 38.81 116.32 40.88 114.88 41.84 120.23 47.77 124.43 49.41 124.27 45.4 116.57 43.02 115.56 40.97 110.77 42.09 109.31 45.05 107.97 46.75 108.93 56.37 109.31 58.42 106.84 61.91 109.43 58.47 106.67 54.79 108.47 56.64 105.53 51.74 108.08 49.54 105.56 46.38 108.18 41.29 105.17 39.08 106.46 40.29 113.07 38.97 114.47 29.91 107.32 27.97 109.73 28.78 103.19 32.01 106.88 26.07 97.37 13.19 83.78 13.78 78.88 11.36 72.14 12.28 63.05 8.16 54.92 0.82 47.46 0 42.25 2.61 35.26 6.91 31.47 3.73 33.64 7.7 15.62 6.2 7.98 3.72 5.97 4.82 0 90.59 0.11 91.28 30.05"
  }));
});

var CO = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 184.55"
  }, React.createElement("polygon", {
    points: "250.26 45.6 256 182.08 131.15 184.55 0 181.96 7.29 0 126.41 2.44 248.47 0.14 250.26 45.6"
  }));
});

var CT = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 183.66"
  }, React.createElement("polygon", {
    points: "97.69 2.82 122.08 4.2 122.24 8.79 127.9 8.22 128.65 4.2 254.25 5.51 256 94.08 255.04 112.27 251.73 116.54 249.85 128.93 245.49 129.59 247.53 126.98 244.45 124.89 234.11 124.86 224.47 129.78 218.16 123.82 214.59 131.06 203.47 128.9 202.73 133.55 199.15 131.24 191.07 136.16 183.18 131.91 182.98 124.69 177.19 121.55 182.21 129.47 180.88 133.66 182.69 134.97 180.2 137.34 169.18 135.39 161.84 140.96 159.94 138.55 157.49 139.69 148.97 136.17 141.4 137.9 138.08 141 130.83 138.23 122.22 140.77 112.06 139.94 109.32 137.33 108.42 132.41 96.15 147.07 90.71 147.94 81.44 155.92 77.26 157.12 74.15 154.2 68.76 157.78 66.95 156.57 62.37 162.56 58.25 161.23 50.15 164.7 33.05 176.13 29.46 175.39 26.89 179.66 25.68 178.15 18.35 182.48 15.65 180.24 9.97 183.66 0 167.23 32 147.39 24.07 133.75 33.72 0 97.69 2.82"
  }));
});

var DC = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 213.13 256"
  }, React.createElement("polygon", {
    points: "213.13 138.61 97.77 256 98.51 211.66 91.34 147.01 49.42 121.28 40.01 108.59 0 75.23 74.52 0 213.13 138.61"
  }));
});

var DE = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.8 256"
  }, React.createElement("polygon", {
    points: "51.35 5.72 44.02 12.17 42.45 19.65 34.14 31 27.5 34.89 25.98 42.52 31.29 48.27 32.83 54.88 28.67 65.57 42.28 90.76 46.73 92.11 51.01 97.55 55.28 108.88 54.58 125.25 56.63 142.31 60.66 144.81 67.29 157.95 68.76 169.24 89.12 191.22 101.12 192.81 102.29 195.09 104.09 214.92 102.62 221.81 102.07 213.14 100.12 210.44 93.19 210.47 95.64 218.03 90.79 218.05 98.72 221.81 95.44 224.98 85.48 227.72 82.89 230.82 85.87 230.81 82.91 234.6 94.78 230.78 99.22 235.13 104.55 225.88 106.8 255.94 102.16 254.61 100.99 256 10.35 255.94 0 21.48 11.83 6.63 26.25 0 41.42 0.89 51.35 5.72"
  }));
});

var FL = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.57 256"
  }, React.createElement("polygon", {
    points: "181.68 255.5 181.33 255.6 181.86 255.36 181.68 255.5"
  }), React.createElement("polygon", {
    points: "195.05 254.83 195.35 255.49 192.44 256 192.59 255.4 195.05 254.83"
  }), React.createElement("polygon", {
    points: "198.1 254.07 198.25 254.73 195.57 255.49 196.09 253.89 198.1 254.07"
  }), React.createElement("polygon", {
    points: "181.68 253.91 182.02 254.25 181.98 255.04 180.75 253.98 181.68 253.91"
  }), React.createElement("polygon", {
    points: "206.72 251.71 206.57 252 206.23 251.72 206.47 251.55 206.72 251.71"
  }), React.createElement("polygon", {
    points: "211.81 251.53 211.42 251.63 212.03 251.09 212.09 251.25 211.81 251.53"
  }), React.createElement("polygon", {
    points: "205.71 251.51 204.95 251.35 205.14 250.7 205.4 250.73 205.71 251.51"
  }), React.createElement("polygon", {
    points: "201.63 250.42 203.35 252.62 198.74 254.45 200.7 251.82 202.6 252.88 201.63 250.42"
  }), React.createElement("polygon", {
    points: "204.28 251.04 203.17 251.47 203.04 250.06 203.81 250.28 204.28 251.04"
  }), React.createElement("polygon", {
    points: "210.08 250.78 209.29 250.25 209.33 249.84 209.9 250.21 210.08 250.78"
  }), React.createElement("polygon", {
    points: "218.31 250.02 216.42 249.73 219.81 248.68 219.68 249.06 218.31 250.02"
  }), React.createElement("polygon", {
    points: "209.19 252.05 208.41 252.64 206.04 247.86 207.54 248.92 209.19 252.05"
  }), React.createElement("polygon", {
    points: "222.67 248.09 220.05 249.2 223.91 247.09 222.67 248.09"
  }), React.createElement("polygon", {
    points: "228.19 245.09 228.19 245.75 226.34 246.01 228.26 244.45 228.19 245.09"
  }), React.createElement("polygon", {
    points: "231.15 243.84 230.44 244.17 231.76 243 231.81 243.18 231.15 243.84"
  }), React.createElement("polygon", {
    points: "233.66 242.08 233.29 242.22 234.65 240.66 234.38 241.33 233.66 242.08"
  }), React.createElement("polygon", {
    points: "219.4 227.66 218.87 227.72 218.66 226.44 219.72 226.54 219.4 227.66"
  }), React.createElement("polygon", {
    points: "217.26 225.35 218.09 225.32 218.03 226.33 216.92 225.41 217.26 225.35"
  }), React.createElement("polygon", {
    points: "243.67 232.2 236.06 240.31 235.38 240.32 243.81 229.57 243.39 227.31 247.49 225.03 243.67 232.2"
  }), React.createElement("polygon", {
    points: "248.7 222.28 247.96 222.66 249.68 219.07 249.5 220.59 248.7 222.28"
  }), React.createElement("polygon", {
    points: "250.69 212.08 249.87 212 250.52 209.93 250.75 209.93 250.69 212.08"
  }), React.createElement("polygon", {
    points: "208.16 206.87 205.84 207.33 205.82 205.84 206.2 205.52 208.16 206.87"
  }), React.createElement("polygon", {
    points: "204.96 204.94 205.15 206.6 203.04 205.59 203.63 204.93 204.96 204.94"
  }), React.createElement("polygon", {
    points: "197.59 203.53 198.15 204.11 197.09 205.01 196.46 203.63 197.59 203.53"
  }), React.createElement("polygon", {
    points: "202.47 204.73 202.14 205.4 201.7 203.47 202.37 203.79 202.47 204.73"
  }), React.createElement("polygon", {
    points: "181.94 181.79 185.5 182.35 180.74 182.04 179.34 178.31 181.94 181.79"
  }), React.createElement("polygon", {
    points: "178.53 175.09 178.65 175.95 177.48 172.47 177.97 172.73 178.53 175.09"
  }), React.createElement("polygon", {
    points: "183.64 179.95 182.68 179.66 180.35 172.49 182.18 173.47 183.64 179.95"
  }), React.createElement("polygon", {
    points: "177.53 171.07 177.27 171.93 176.78 168.28 177.41 169.42 177.53 171.07"
  }), React.createElement("polygon", {
    points: "166.24 147.66 166.37 148.25 163.25 143.97 164.16 144.54 166.24 147.66"
  }), React.createElement("polygon", {
    points: "165.96 139.48 166.07 139.43 166.01 139.51 165.96 139.48"
  }), React.createElement("polygon", {
    points: "165.96 139.48 165.32 139.74 165.58 139.3 165.96 139.48"
  }), React.createElement("polygon", {
    points: "250 153.43 245.62 144.94 240.3 127.96 243.18 133.98 250 153.43"
  }), React.createElement("polygon", {
    points: "233.93 115.48 233.67 115.48 233.25 113.86 233.82 115.11 233.93 115.48"
  }), React.createElement("polygon", {
    points: "234.45 100.48 232.9 105.57 233.21 113.77 230.1 102.48 232.97 99.54 234.45 100.48"
  }), React.createElement("polygon", {
    points: "163.87 93.57 164.45 93.71 164.18 94.48 163.42 94.04 163.87 93.57"
  }), React.createElement("polygon", {
    points: "163.92 92.7 163.4 92.65 163.5 91.64 164.22 92.06 163.92 92.7"
  }), React.createElement("polygon", {
    points: "152.09 77.93 151.36 77.97 151.39 77.43 151.64 77.22 152.09 77.93"
  }), React.createElement("polygon", {
    points: "83.23 54.89 82 56.85 78.95 54.63 81.48 54.45 83.23 54.89"
  }), React.createElement("polygon", {
    points: "87.07 57.89 84.37 58.03 82.77 57.14 86.48 57.53 96.63 52.3 87.07 57.89"
  }), React.createElement("polygon", {
    points: "99.49 51.43 97.59 51.77 100.62 50.27 99.49 51.43"
  }), React.createElement("polygon", {
    points: "34.66 25.08 11.69 26.8 9.84 26.45 30.04 24.32 36.02 25.14 34.66 25.08"
  }), React.createElement("path", {
    d: "M88.07,61.43l7.38-9.91-1-4.11-1.72-.14-.42,3.82-1.52-.15-.43-4.57-5.09-3.74,0,2.59,1.58.1-2.58,1.55,5.37,1.68-3.26,7.34-5.47-5.37,2.55,4,.67,2.67-4.59-9,6.88-21.48,1.23-9.55L85.85,13l1.86.81-.07-4L84.5,7,82.12-1.38,74-1.72l-5.77-9-6.3-4.82.35-4.74-4.88-2.95-4.45-7.58L41.55-38.29l-5.23,1.17-1-1.35-6.22,3,1.45,2.16L27-34.77l-.44.58,4.1,1.79-.26,1.72-1,.55L25-31.61,12.42-24.7l.16-2.76L8-24.18l-11.61,1L-5-24.66l-.54-5.27L-3-23.52l1.1-4.2-1.7-3.58-10.51-9.94,7.81,4.74,1.65-1.31-2.29.71-.94-4.13-2.57.93-4.94-3.38,5.69-3.23-.67-1.43-4.54,2.69-1.43-2.86-3.44,2,3.25,1.43,1,3.81-11.33-7.15L-41.6-53.08l5.48.75,1.26-1.55,2.27,1.71-.13-1.59,4.29,2.39-.52-4.05-2.27-.95L-38.06-55l0-2.2-2.53-.36-4,3.91-6-.46-14,1.67,10.32-2.92L-58.27-58l1.86-2-2.2-1.8-2.46,6-2.65-5.42.56,4.31-3.92,4.35-9,2.57,6.56-5.93-3-3.62,1.45-5.42-6.93-8L-76.63-78,9.72-73.89l4,11,88,8,2.39,7.76,3.95-.38.37-14,2.67-3.13,17.41,4.65,0,6.83-1.7-3.75-.39,2.69,3,3.68,5.1,25.8L145.86,3.2l10.08,16.12,3.39,6.87-2.24,2.75.09,7.49,4.9,13.18-5.85-13.14.62-15.2-5.65-.45.46-5-3.27-1.87,3.78,16.12,12.35,27.29,1.26,5.85L171,76.07l-.7-1.11L166.9,73.7l5.75,4,3.92,12.62-2.87,40.05-.16-4.87-6,11-.21,9.55-3.8,4.61.74,2.55L162.52,151l-1.68.89,1.41.42.54,1.39-2.21-1-.23-1.85L153,154.88l-4.64-1.66-8.14,2.5L138,154l-.93-3.61,1.61-3.3,1.83,2.77,3.25,1.48-.72.79,2.87-1.91-7.63-4.68-1.62-6.78-6.43-10.68-8.75-4.32-3.82,1,2.38-2.34-2.35-.76-1.9-5.38-.49,1.58-1.83-13.54-.92-1.83-.18,2-4.13-1.19,7.92-9.23-4.41,2.77-1.59,3.81-3.58,0-1.35-14.14,4.14-3.32-6.14,2.59L99.13,82.3l4.2,8.26-5.65-1.84-8.4-16.6-.35-4.59-4.27-2.37-1-2.33,2.45,2.09-.69-1.62,3.06,0-1.63-.82,2.24-1.35-1,.26m61.42,14.33-9.78,8.77,7.12,8.31,5.35,2.36L156.42,84l-2.11-5.23Z",
    transform: "translate(78 78)"
  }));
});

var GA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.48 256"
  }, React.createElement("polygon", {
    points: "189.02 235.63 187.17 228 190.68 222.71 188.87 232.07 189.02 235.63"
  }), React.createElement("polygon", {
    points: "25.05 141.63 19.03 128.72 14.93 113.08 0 0 112.49 1.64 103.64 11.44 101.43 17.54 109.86 22.86 115.3 29.3 123.91 31.34 129.65 47.27 136.83 58.44 150.43 68.89 154.94 77.75 165.79 85.43 166.13 91.73 170.25 94.33 169.94 97.29 173.24 99.56 174.06 102.97 185.26 109.29 190.69 125.41 190.59 132.03 200.17 139.61 203.47 148.54 203.37 158.72 217.48 165.84 214.35 168.75 212.74 167.35 211.56 169.87 213.41 171.04 210.79 173.46 204.32 171.21 205.65 172.94 203.19 174.11 208.03 175.59 205.01 180.25 197.13 179.06 200.77 181.66 198.78 184.66 202.65 184.29 203.23 182.42 204 184.35 202.2 189.94 198.47 185.86 200.76 188.43 194.34 190.39 197.37 192.06 196.29 194.11 202.04 191.44 197.74 199.61 194.67 197.35 197.23 202.34 187 200.95 194.75 203.77 197.62 206.85 192.1 213.3 190.32 209.05 188.83 209.81 189.01 214.68 186.92 214.19 190.03 217.06 191.27 214.43 190.34 219.72 186.1 216 189.08 219.89 185.84 221.98 189.1 223.09 186.84 226.28 187.18 229.5 185.24 229.14 186.86 236.89 164.97 231.15 161.22 235.64 162.67 244.34 160.9 255.44 154.85 256 151.81 245.07 26.96 235.05 21.07 220.36 20.73 214.72 16.96 209.35 20.22 190.08 15.89 174.12 21.66 155.26 28.03 150.01 23.75 146.18 25.05 141.63"
  }));
});

var HI = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.93 47.26"
  }, React.createElement("polygon", {
    points: "62.96 29.9 68.25 31.87 73.93 38.37 62.02 47.26 58.84 45.09 56.75 35.38 60.02 31.73 59.37 27.92 62.96 29.9"
  }), React.createElement("polygon", {
    points: "49.82 24.36 48.45 24.6 47.85 24.29 49.62 23.21 49.82 24.36"
  }), React.createElement("polygon", {
    points: "45.44 21.16 44.08 21.07 42.98 18.95 45.91 19.45 45.44 21.16"
  }), React.createElement("polygon", {
    points: "49.42 17.04 50.92 19.03 54.07 18.45 57.4 21.49 51.81 23.5 47.74 18.71 49.42 17.04"
  }), React.createElement("polygon", {
    points: "40.51 14.41 45.27 15.28 47.74 15.28 40.06 16.37 40.51 14.41"
  }), React.createElement("polygon", {
    points: "31.61 9.03 33.97 11.01 34.15 13.8 30.34 11.92 28.84 13.37 26.5 9.41 30.54 7.41 31.61 9.03"
  }), React.createElement("polygon", {
    points: "0.43 5.96 0 4.71 2.34 2.89 2.14 4.36 0.43 5.96"
  }), React.createElement("polygon", {
    points: "11.89 0.01 10.49 5.03 6.03 2.71 8.71 0 11.89 0.01"
  }));
});

var IA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 166.15"
  }, React.createElement("polygon", {
    points: "235.29 52.66 235.32 54.57 243.82 60.83 245.17 66.48 254.66 72.98 256 77.5 254.5 87.98 250.04 92.73 248.68 100.4 245.03 103.84 234.67 109.1 221.67 111.5 219.22 121.02 224.64 127.24 225.64 134.34 220.45 142.1 217.88 151.04 207.97 156.15 208.96 166.15 204.43 165.71 194.56 154.46 101.94 157.47 30.94 154.95 30.81 151.75 27.01 148.01 29.05 139.55 26.99 130.14 28.34 124.27 25.54 122.5 27.86 117.18 24.37 115.51 25.89 109.38 22.89 107.92 23.18 104.71 19.74 104.13 20.5 89.84 17.47 85.53 17.59 80.76 10.48 70.23 8.88 53.41 5.57 52.14 4.19 44.92 0 39.99 7.76 20.11 6.95 15.04 3.48 14.28 5.22 6.54 2.92 0 109.23 1.95 209.95 0.8 211.73 7.56 216.56 10.38 213.64 18.81 217.63 38.3 220.45 42.24 232.61 45.11 235.29 52.66"
  }));
});

var ID = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.6 256"
  }, React.createElement("polygon", {
    points: "159.36 165.84 160.6 256 80.06 255.63 0 252.5 3.43 186.45 7.79 174.1 5.87 170.67 0.19 169.27 0.37 162.58 9.96 149.26 11.12 143.57 21.87 123.32 19.96 117.36 12.8 111.61 8.66 94.39 14.76 0 38.28 1.36 36.45 37.08 43.94 48.44 43.36 53.63 45.53 56.49 43.39 57.75 52.7 64.57 66.11 84.89 68.58 83.8 70.85 87.64 76.79 86.82 73.71 104.09 71.92 105.17 74.55 115.07 70.34 118.73 71.68 121.61 70.34 126.48 76.43 129.73 84.43 122.02 89.08 125.55 91.11 136.38 98.03 146.87 98.02 152.62 100.56 155.13 105.48 155.84 109.12 167.11 113.16 170.34 115.44 166.32 124.77 167.46 128.6 163.48 148.78 164.11 147.87 160.7 150.9 156.66 159.36 165.84"
  }));
});

var IL = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.91 256"
  }, React.createElement("polygon", {
    points: "130.3 1.94 130.08 13.54 140.3 37.1 140.89 146.18 137.96 148.13 138.58 153.39 136.17 157.44 140.92 164.81 141.91 173.75 136.53 182.63 136.87 186.06 132.93 187.75 129.85 195.48 126.32 195.26 124.65 198.31 126.77 201.66 123.29 204.53 125.56 205.18 122.73 206.66 123.02 213.4 120.33 213.72 122.97 216.72 120.82 217 122.61 219.48 118.47 225.65 121.14 232.49 106.53 237.41 107.77 250.71 105.3 252.02 87.61 244.77 81.03 252.13 83.03 255.96 81.06 256 78.03 251.15 76.23 251.68 77.44 254.94 73.68 252.75 68.42 242.52 71.51 236.55 68.58 229.9 68.66 223.58 54.25 210.75 47.44 207.68 38.51 197.81 38.02 192.68 44.89 178.97 47.01 168.93 36.86 163.61 31.11 167.59 28.55 165.55 24.8 148.94 3.98 127.23 0.25 114.46 0 102.78 1.51 98.41 5.09 96.46 4.41 88.21 13.26 84.3 20.85 70.23 20.35 64.04 15.98 58.37 18.6 50.25 29.98 48.85 39.23 44.84 48.26 31.6 49.19 18.63 41.32 12.5 40.45 7.53 33.49 0 130.3 1.94"
  }));
});

var IN = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.48 256"
  }, React.createElement("polygon", {
    points: "167.09 4 167.36 171.97 164.9 174.3 167.47 179.91 164.75 183.46 169.48 185.14 168.42 191.47 161.88 191.69 149.28 198.14 145.66 195.12 135.69 196.09 137.74 207.24 132.09 212.72 128.87 213.22 125.06 222.99 120.32 225.55 116.7 225.07 113.07 231.33 111.5 241.07 105.34 244.87 94.75 239.05 93.14 232.94 88.52 230.26 91.05 233.34 86.79 235.37 84.47 233.92 85.36 238.34 81.52 240.14 81.22 246.73 77.82 247.92 76 252.13 74.03 251.46 75.04 249.05 68.46 247.53 66.17 242.9 55.85 247.66 50.68 256 48.35 252.2 36.18 245.86 28.8 247.57 26.34 243.44 26.6 249.4 24.69 252.57 22 252.34 21.74 247.84 16.06 249.57 10.41 245.98 9.11 247.84 10.75 252.57 8.05 255.59 0.73 253.06 3.57 252.15 0 247.85 3.78 247.5 3.65 238.06 7.66 236.1 4.52 235.1 9.5 231.23 6.68 226.45 9.13 222.25 11.18 223.55 12.73 221.16 14.06 222.69 19.14 214.56 18.68 212.01 24.27 209.8 23.94 204.99 31.82 192.77 29.66 185.32 30.8 180.22 24.46 169.71 28 164.15 27.34 156.75 31.53 154.15 35.32 1.49 38.27 4.72 39.83 4.15 40.7 6.86 46.28 8.14 59.04 4.93 68.13 0 167.04 0.23 167.09 4"
  }));
});

var KS = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 132.01"
  }, React.createElement("polygon", {
    points: "256 129.85 128.45 132.01 0 128.92 5.37 0 117.14 2.92 228.07 1.68 235.73 7.45 240.41 5.54 243.07 12.3 239.94 12.55 235.52 20.8 242.78 27.67 245.37 34.81 252.81 37.68 256 129.85"
  }));
});

var KY = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 108.34"
  }, React.createElement("polygon", {
    points: "2.41 105.82 0.2 105.75 0 103.37 2.26 103.59 2.41 105.82"
  }), React.createElement("polygon", {
    points: "167.13 2.9 173.43 1.9 177.91 5.46 180.84 13.57 192.38 16.11 197.38 21.27 203.27 18.34 210.84 22.71 215.89 21.92 219.79 17.81 224.52 16.53 226.59 23.14 234.51 30.01 235.22 37.19 233.14 40.84 241.28 54.87 250.5 65.29 256 66.46 243.34 77.65 232.39 83.78 226.25 93.77 219.77 95.93 217.59 100.08 197.34 107.28 58.59 102.58 50.98 100.31 51.47 108.34 4.77 106.06 6.91 100.55 11.65 103.01 14.88 96.72 16.12 87.24 14.34 82.94 17.97 77.96 23.78 76.8 37.65 83.67 39.47 81.07 37.15 73.96 38.1 70.59 51.57 66.72 49.69 59.4 53.64 53.57 56.73 54.74 58.52 52.8 57.78 48.85 62 50.91 65.71 49.85 66.57 53.3 68.46 52.04 68.73 47.04 70.29 49.74 75.1 48.71 84.42 55.44 87.86 50.08 94.61 47.09 100.9 53.18 104.35 49.73 104.61 45.45 107.11 44.32 106.59 41.44 110.86 41.13 109.25 39.1 112.23 40.89 113.21 44.88 120.03 48.76 124.07 46.35 127.61 36.01 133.06 34.75 135.63 28.44 141.45 24.64 140.23 17.38 146.72 16.85 149.03 18.85 157.28 14.79 161.1 14.94 162.29 10.61 159.23 9.46 161.03 7.19 159.42 3.52 164.11 0 167.13 2.9"
  }));
});

var LA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 229.19"
  }, React.createElement("polygon", {
    points: "151.68 223.33 153.7 223.5 154.88 223.82 153.11 223.85 151.68 223.33"
  }), React.createElement("polygon", {
    points: "151.68 223.33 151.57 223.32 151.07 223.11 151.68 223.33"
  }), React.createElement("polygon", {
    points: "166.56 222.55 165.14 223.32 161.35 224.31 160.47 223.98 166.56 222.55"
  }), React.createElement("polygon", {
    points: "178.01 223.37 175.49 223.11 173.16 221.88 176.08 222.43 178.01 223.37"
  }), React.createElement("polygon", {
    points: "184.45 221.76 181.36 222.98 183.1 221.57 184.45 221.76"
  }), React.createElement("polygon", {
    points: "176.02 213.07 175.91 213.7 176.18 211.64 176.76 211.39 176.02 213.07"
  }), React.createElement("polygon", {
    points: "197.19 213.68 197.14 212.43 200.51 210.52 200.52 211.29 197.19 213.68"
  }), React.createElement("polygon", {
    points: "202.52 209.69 201.79 210.17 201.31 210.15 201.85 209.51 202.52 209.69"
  }), React.createElement("polygon", {
    points: "238.47 198.05 236.53 198.31 239.38 196.25 239.26 197.5 238.47 198.05"
  }), React.createElement("polygon", {
    points: "192.81 197.1 197 198.4 198.47 200.52 192.99 198.96 192.81 197.1"
  }), React.createElement("polygon", {
    points: "242.88 195.05 242.54 195.23 244.86 192.66 243.24 194.72 242.88 195.05"
  }), React.createElement("polygon", {
    points: "248.73 188.38 248.28 188.78 248.21 188.71 248.94 188.13 248.73 188.38"
  }), React.createElement("polygon", {
    points: "108.87 199.5 106.97 199.86 97.3 193.55 103.13 190.59 112.88 194.29 108.87 199.5"
  }), React.createElement("polygon", {
    points: "250.79 185.78 250.15 186.36 253.2 182.07 252.48 183.34 250.79 185.78"
  }), React.createElement("polygon", {
    points: "225.5 181.51 225.93 183.1 224.34 181.6 222.85 183.61 223.44 179.69 225.5 181.51"
  }), React.createElement("polygon", {
    points: "230.35 179.11 233.22 179.03 232.62 181.36 230.28 179.43 230.35 179.11"
  }), React.createElement("polygon", {
    points: "232.65 172.76 232.91 171.97 235.09 171.27 235.07 172.22 232.65 172.76"
  }), React.createElement("polygon", {
    points: "230.81 173.17 230.54 173.25 233.14 169.43 232.08 171.71 230.81 173.17"
  }), React.createElement("polygon", {
    points: "255.28 178.43 254.13 180.8 255.63 171.36 252.7 164.48 255.53 168.63 256 172.47 255.28 178.43"
  }), React.createElement("polygon", {
    points: "225.41 160.57 225.11 161.1 224.7 160.94 225.32 160.25 225.41 160.57"
  }), React.createElement("polygon", {
    points: "235.64 163.43 237.21 164.71 235.56 166.43 233.61 164.27 229.44 164.78 237.35 158.75 234.07 162.62 235.64 163.43"
  }), React.createElement("polygon", {
    points: "20.13 183.44 13.68 183.79 7.97 186.89 5.36 182.06 5.7 180.18 9.61 179.81 11.68 175.8 10.53 170.95 14.48 165.93 14.94 155.48 12.78 149.32 15.4 143.69 14.14 138.46 21.95 124.19 23.75 117.18 21.87 113.52 24.95 111.64 22.8 108.51 23.39 103.13 20.87 102.79 17.28 95.86 18.35 92.84 14.11 87.17 14.94 84.81 10.01 80.3 9.64 69.18 0 57.3 0.91 0.06 137.85 0 138.07 2.41 142.43 5.09 138.47 13.76 142.66 17.09 138.02 19.68 141.38 25.25 141.17 31.01 150.5 39.65 144.91 48.91 141.88 49.3 142.16 56.49 129.75 66.44 125.83 81.6 121.36 85.75 123.02 90.78 121.47 97.45 115.69 98.74 119.14 110.89 115.36 114.08 208.93 112.53 203.97 130.61 206.41 137.14 212.53 143.15 217.29 156.87 220.38 157.86 216.99 160.05 216.94 158.29 211.44 159.1 209.23 155.64 198.52 154.36 194.01 149.06 187.56 147.47 177.18 157.34 175.9 161.7 178.56 165.21 190.18 168.17 197.46 166.39 203.02 160.46 207.6 163.51 210.07 159.13 209.84 163.42 212.72 161.05 211.46 159.87 213.47 159.68 214.87 160.97 211.18 167.14 207.09 166.23 205.18 168.52 206.72 172.12 211.75 171.48 210.8 173.44 214.03 175.98 217.07 175.04 218.72 168.77 222.5 164.4 225.46 166.48 228.13 165.46 224.21 170 228.41 171.33 225.27 172.66 226.35 174.18 228.5 173.14 227.36 175.37 230.42 175.28 228.11 177.98 229.9 180.28 226.57 181.93 223.07 178.13 220.72 182.57 217.35 183.85 218.21 186.44 221.34 186.43 223.38 189.39 212.42 185.4 216.62 189.96 209.83 189.75 213.88 195.65 221.61 198.74 220.91 202.83 230.98 202.94 228.84 204.57 233.78 204.73 235.68 207.03 237.96 204.84 242.3 209.76 240.63 211.35 246.36 212.32 247.54 214.65 243.26 215.65 246.94 216.22 244.99 219.75 243.23 217.91 244.02 220.21 242.93 219.05 240.81 222.03 241.73 224.94 235.88 218.91 235.84 221.23 232.89 222.15 227.92 229.19 234.37 215.89 233.02 217.8 232.07 214.72 232.02 218.26 229.15 220.13 224 211.5 225.34 211.03 217.74 210.93 216.37 206.26 213.78 208.1 206.87 207.66 210.36 204.77 209.22 201.83 206.51 201.24 207.12 198.85 205.36 198.57 204.99 200.64 200.93 199.57 193.02 195.2 191.67 196.39 188.9 193.33 187.58 196.99 196.92 201.68 196.35 206.75 195.28 205.62 197.4 209.04 193.57 209.95 194.2 213.24 195.82 212.98 192.81 217.87 186.41 220.98 185.37 210.93 184.09 212.91 181.44 208.65 178.81 212.56 176.18 206.13 174.33 209.94 168.38 209.1 169.31 213.51 167.25 213.19 166.66 218.58 165.5 217.24 160.86 220.07 158.5 219.48 159.85 217.15 156.42 216.39 154.59 219.16 148.26 216.51 147.99 214.18 144.83 215.78 134.59 212.23 132.44 210.33 131.84 207.83 134.15 208.71 137.59 205.45 138.01 207.53 140.66 207.73 141.09 212.74 143.11 211.56 142.65 207.76 135.57 200.44 137.17 192.57 135.72 192.27 133.78 199.63 127.56 197.59 127.28 195.06 120.85 196.67 120.73 190.79 116.61 190.67 116.88 185.19 106 186.56 106.5 180.21 99.75 180.22 92.37 185.66 92.02 183.93 89.02 184.07 90.52 187.96 94.08 187.14 92.03 188.35 93.73 192.2 97.81 191.8 95.79 194.03 83.42 196.51 63.8 193.14 39.66 182.88 20.13 183.44"
  }));
});

var MA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 156.18"
  }, React.createElement("polygon", {
    points: "249.82 142.89 254.02 153.99 246.62 156.18 234.7 152.94 248.18 150.45 250.43 146.86 246 150.15 248.7 144.18 247.83 141.61 249.82 142.89"
  }), React.createElement("polygon", {
    points: "219.18 145.14 217.83 145.84 215.26 142.67 218.45 139.18 219.18 145.14"
  }), React.createElement("polygon", {
    points: "208.52 135.27 207.77 137.53 211.19 135.53 211.91 137.87 209.76 139.47 214.03 140.78 214.8 145.65 203.37 146.31 195.38 150.28 191.02 146.24 196.97 144.88 203.71 136.77 208.52 135.27"
  }), React.createElement("polygon", {
    points: "250.93 126.81 249.54 127.14 252.85 117.21 253.87 119.21 250.93 126.81"
  }), React.createElement("polygon", {
    points: "187.5 1.11 191.5 0.82 191.9 5.71 188.06 5.74 193.3 10.09 195.41 16.2 191.97 13.02 192.26 16 197.81 19.51 195.44 20.18 196.73 21.86 200.68 22.2 202.05 24.21 202.2 20.78 205.56 18.18 208.07 23.93 200.21 29.05 187.25 33.39 186.31 36.73 188.95 34.71 190.1 37.05 184.17 40.3 186.35 43.86 181.28 42.94 182.08 50.48 178.9 48.48 179.61 50.5 176.08 49.27 175.25 50.53 177.68 52.48 175.72 53.17 176 55.45 179.2 55.14 178.82 57.75 181.4 58.07 181.95 61.61 188.19 59.5 185.94 54.38 197.15 62.22 208.12 83.02 204.77 83.7 206.23 83.09 203.96 78.48 202.82 83.72 200.38 83.75 205.83 89.02 211.47 90.34 212.46 102.24 214.55 104.72 222.02 108.94 231.07 109.65 226.76 111.34 233.32 110.78 249.15 104.13 250.64 101.68 248.95 93.02 251.41 91.61 247.72 89.72 245.6 94.39 242.82 79.95 237.99 78.26 236.78 81.82 232.6 77.47 234.19 75.12 238.97 75.23 245.79 79.23 251.57 86.38 256 99.5 252.95 98.18 252.12 103.49 255.39 103.83 255.27 115.21 237.6 116.81 231.39 121.69 232.18 118.26 222.84 120.98 220.91 119.01 214.81 126.39 201.79 129.68 204.13 125.14 203.61 114.95 206.06 110.62 204.87 109.52 203.58 111.36 199.81 108.89 199.69 114.66 197.79 114.46 195.31 118.68 193.62 117.49 189.89 120.33 190.26 123.87 185.91 119.35 182.93 129.3 176.29 132.15 174.15 131.19 176.01 129.29 174.67 126.67 173.86 129.13 171.19 128.65 172.19 130.6 170.41 131.61 169.67 117.43 165.16 115.95 171.09 104.39 166.42 111.16 163.2 110.72 162.07 112.83 155.82 106.31 154.81 95.52 151.84 94.48 151.25 83.52 53.41 81.21 52.97 83.39 49.88 83.66 49.83 81.16 1.85 78.18 0 75.79 19.44 11.83 156.87 17.9 164.63 12.97 168.5 6.84 173.24 6.49 183.65 0 187.5 1.11"
  }));
});

var MD = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 133.53"
  }, React.createElement("polygon", {
    points: "201.44 128.18 200.36 131 198.34 129.64 200.77 128.48 198.56 125.17 201.44 128.18"
  }), React.createElement("polygon", {
    points: "200.02 115.78 197.19 116.11 196.26 114.44 198.54 113.09 200.02 115.78"
  }), React.createElement("polygon", {
    points: "244.99 125.12 248.57 115.41 253.42 105.4 247.81 121.98 244.99 125.12"
  }), React.createElement("polygon", {
    points: "255.07 101.57 254.16 102.87 255.19 94.22 256 94.2 255.07 101.57"
  }), React.createElement("polygon", {
    points: "14.65 0.34 211.81 1.49 217.56 94.87 253.69 94.26 252.01 94.81 253.04 97.14 248.13 96.95 251.46 98.31 250.59 100.92 253.35 101.83 252.71 104.41 249.38 110.56 247.42 110.69 247.97 108.53 245.34 110.26 242.59 119.04 238.4 121.34 237.37 126.27 223.11 128.4 221.83 130.95 213.43 130.18 209.29 133.53 209.97 128.88 207.59 129.36 215.83 120.19 209.45 121.79 213.84 117.7 212.81 116.69 204.3 118.53 204.95 114.23 211.3 111.19 206.15 108.51 209.71 98.63 202.91 110.24 200.91 105.46 203.26 102.64 202.68 100.99 201.21 101.85 198.53 105.76 198.55 111.43 188.46 99.77 188.15 105.31 182.07 93.78 183.95 91.83 185.28 94.37 186.48 90.26 190.53 86.9 188.97 85.62 183.93 87.21 185.63 84.64 184.4 82.64 191.1 82.13 191.13 84.09 198.11 86.04 202.18 83.81 202.57 79.94 198.88 84.02 195.87 82.78 195.07 80.03 191.49 80.52 194.26 78.02 190.79 78.4 190.65 74.99 188.4 77.7 187.28 71.5 184.41 75.03 184.37 70.63 182.78 77.11 180.38 77.86 184.28 66.7 189.91 71.48 193.53 70.75 193.77 68.41 191.84 70.36 189.8 68.45 194.13 63.88 191.32 62.63 191.65 60.45 189.19 62.47 189.36 59.35 186.57 57.36 181.26 61.15 181.69 64.51 179.49 64 181.98 52.82 186.28 55.6 190.48 55.19 190.43 50.73 196.28 44.09 189.98 45.77 187.69 52.27 185.04 43.55 189.86 31.61 193.17 28 209.04 27.32 198.83 25.49 203.48 19.79 208.96 20.73 205.79 17.25 209.27 11.62 199.98 20.38 203.37 10.23 200.27 13.3 194.95 13.74 192.86 18.39 195.91 21.1 187.84 28.05 186.47 19.96 184.56 27.03 185.74 29.58 183.6 32.07 181.99 25.29 176.85 26.08 180.81 29.12 178.74 31.91 175.2 31.58 176.91 36.14 172.19 32.15 174.26 36.1 177.74 37.74 175.41 39.73 167.16 34.78 164.2 35.94 171.9 43.32 173.9 42.39 175.9 49.88 170.52 48.53 177.44 53.21 173.67 55.33 168.95 49.72 167.37 50.18 174.56 60.17 169.03 57.69 172.5 62.55 169.26 63.06 169.48 67.05 172.35 66.54 168.57 73.13 170.86 76.18 170.93 88.31 177.75 98.34 178.49 102.81 174.28 103.08 163.61 92.38 161.01 78.75 161.41 89.36 164.66 97.61 171 101.67 174.2 106.47 178.43 106.05 177.88 110.62 182.07 116.73 182.74 125.08 176.91 120.59 174.24 113.51 173.53 118.52 171.48 116.55 170.72 119.08 164.45 110.77 156.04 110.95 152.6 102.11 149.52 99.46 151.95 106.55 151.71 108.38 148.97 107.45 140.78 93.38 138.35 97.84 136.38 94.38 134.17 100.19 129.73 100.78 127.47 94.34 129.43 87.79 132.88 86.32 131.93 84.25 135.28 83.3 137.03 78.52 141.73 75.72 141.46 69.48 147.82 63.03 140.18 55.42 136.08 59.55 129.16 56.11 126.94 51.6 117.02 48.84 113.03 43.8 116.23 39.76 115.83 37.1 110.6 33 99.58 29.08 99.84 23.77 96.5 21.89 98.57 17.95 95.71 18.29 94.71 14.9 93.47 16.89 92.34 13.31 94.81 12.07 94.28 9.8 87.31 10.48 78.05 3.02 75.12 2.77 69.6 7.78 60.82 8.47 62.36 10.71 59.59 11.24 60.78 13.07 58.71 15.12 52.52 15.34 42.8 11.62 43.47 9.16 41.4 7.12 39.4 12.2 30.67 20.45 25.57 18.24 22.41 19.3 11.39 30.96 0 37.94 1.51 0 14.65 0.34"
  }));
});

var ME = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.37 256"
  }, React.createElement("polygon", {
    points: "94.58 200.1 91.95 199.45 90.59 195.58 96.03 197.49 94.58 200.1"
  }), React.createElement("polygon", {
    points: "102.78 189.15 101 190.6 102.41 192.25 98.45 192.47 100.05 186.46 102.78 189.15"
  }), React.createElement("polygon", {
    points: "120.33 184.15 115.48 184.17 116.23 187.6 114.32 189.17 110.37 184.68 113.72 177.41 117.13 176.47 120.89 181.29 120.33 184.15"
  }), React.createElement("polygon", {
    points: "88.34 13.81 91.69 15.55 106.61 8.87 110.43 9.55 115.34 5.14 127.66 13.61 134.93 21.87 137.82 90.27 135.9 102.45 144.19 107.83 151.48 109.04 151.75 112.84 149 115.24 151.75 121.45 150.08 128.58 156.5 135.11 159.13 132.06 162.87 133.9 168.57 144.51 167.67 146.99 165.37 146.03 165.24 149.19 161.82 148.65 164.19 153.87 166.64 149.55 168.57 152.71 167.85 148.98 171.37 153.74 162.35 163.98 159.59 163.23 158.83 164.79 156.6 160.23 153.94 160.89 155.2 165.07 153.45 166.96 152.34 163.24 151.56 166.47 147.32 164.19 145.34 171.05 142.97 168.8 140.11 172.56 139.36 167.12 137.65 171.15 137.76 166.8 135.85 167.83 132.82 178.86 132.78 173.6 131.35 178.2 129.59 172.89 127.46 174.7 129.77 178.99 126.17 182.96 123.97 174.04 122.38 172.83 121.03 175.29 120.15 171.41 119.32 174.87 115.68 171.19 117.19 175.73 113.73 174.9 111.44 178.52 110.48 173.69 108.53 173.3 109.1 179.39 108.24 176.91 104.48 178.15 105.86 188.36 97.81 183 94.06 183.79 94.78 180.58 99.21 178.21 98.41 176.1 94.28 178.65 97.41 170.7 94.93 169.34 94.67 174.48 87.1 177.49 89.14 182.75 82.69 194.21 83.64 198.27 78.25 202.61 78.23 205.02 75.16 206.3 77.07 201.69 73.16 205.6 73.5 203.27 70.68 203.75 70.95 198.57 64.49 211.78 63.37 208.08 63.01 211.77 63.73 200.82 61.47 205.06 61.09 213.34 61.01 210.9 57.83 209.41 59.88 206.87 58.46 204.62 59.68 200.4 54.05 208.6 54.53 212.85 56.33 211.25 53.98 216.07 53.2 198.48 48.77 203.45 49.43 204.66 51.2 203.09 52.57 217.61 50.93 219.63 48.93 209.46 48.7 213.57 44.28 217.86 46.88 211.9 42.48 217.03 45.84 210.66 42.89 211.82 44.38 209.84 35.88 215.9 33.65 221.32 31.3 222.07 34.53 223.05 34.69 227.41 28.73 228.55 27.57 232.78 29.56 233.69 20.44 240.59 14.23 255.48 11.11 253.85 10.59 256 7.22 251.33 7.5 246.3 1.09 237.43 0 124.89 4.9 122.68 7.85 129.24 11.47 118.23 16.23 120.41 18.56 119.3 15.04 113.35 21.08 105.04 28.2 101.39 28.49 96.24 34.93 89.4 32.8 85.82 33.09 80.14 35.97 76.59 34.56 72.38 38.52 63.84 43.24 60.34 46.27 43.64 77.34 0 84.57 1.3 84.99 10.86 88.34 13.81"
  }));
});

var MI = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.01 256"
  }, React.createElement("polygon", {
    points: "203.23 238.79 202.51 239.03 203.16 235.36 203.28 237.63 203.23 238.79"
  }), React.createElement("polygon", {
    points: "116.61 125.91 115.38 125.41 116.48 124.07 117.43 124.58 116.61 125.91"
  }), React.createElement("polygon", {
    points: "120.28 122.97 118.75 122.88 118.52 119.78 120.08 120.64 120.28 122.97"
  }), React.createElement("polygon", {
    points: "124.36 110.03 124.19 110.71 122.91 108.2 123.72 108.81 124.36 110.03"
  }), React.createElement("polygon", {
    points: "132.39 102.81 129.93 102.17 131.82 95.72 133.69 96.24 132.39 102.81"
  }), React.createElement("polygon", {
    points: "155.21 95.46 161 99.2 168.62 100.58 171.72 105.65 176.52 105.95 192.28 114.25 195.85 123.59 191.67 122.26 190.52 125.01 195.12 132.53 194.89 150.61 189.35 154.25 187.89 162.31 180.28 165.38 178.27 175.75 185.94 180.25 189.84 175.47 191.22 176.35 195.38 168.43 193.4 167.69 197.7 164.98 206.15 161.31 212.13 164.67 215.4 171.22 223.01 202.21 220.49 217.96 217.17 220.54 217.36 215.68 212.09 217.04 213.36 219.06 210.81 220.81 210.26 226.91 203.58 232.46 201.86 238.93 202.38 242.4 194.28 253.62 155.1 256 155.06 253.71 94.76 253.84 100.29 249.3 108.51 234.43 113.22 216.56 113 204.98 110.16 196.35 112.23 194.47 109.32 194.95 104.05 180.38 107.13 172.75 104.87 162.45 112.02 151.01 112 138.66 116.98 136.12 117.43 129.69 121.34 127.05 124.28 128.21 131.73 117.86 129.1 132.13 130.5 134.76 133.66 126.33 132.38 135.53 136.53 125.95 137.14 114.78 149.76 109.57 146.23 108.68 144.36 105.52 144.92 101.41 148.73 97.41 147.27 95.57 155.21 95.46"
  }), React.createElement("polygon", {
    points: "163.6 94.46 164.08 96.57 162.15 97.13 158.59 94.03 163.6 94.46"
  }), React.createElement("polygon", {
    points: "134.24 94.33 133.18 94.68 132.93 93.27 133.02 93.42 134.24 94.33"
  }), React.createElement("polygon", {
    points: "164.09 86.94 163.94 87.46 165.09 88.27 162.81 87.77 164.09 86.94"
  }), React.createElement("polygon", {
    points: "188.73 85.74 186.52 88.86 177.57 86.64 183.05 84.13 182.9 81.77 188.73 85.74"
  }), React.createElement("polygon", {
    points: "171.1 76.64 168.72 74.93 169.09 73.34 170.84 74.73 171.1 76.64"
  }), React.createElement("polygon", {
    points: "170.91 72.7 169.23 72.77 166.43 67.53 168.53 64.96 170.58 65.75 169.15 69.39 170.91 72.7"
  }), React.createElement("polygon", {
    points: "102.19 67.33 103.14 68.36 101.18 68.26 100.89 64.63 102.19 67.33"
  }), React.createElement("polygon", {
    points: "51.65 44.73 53.79 47.37 52.63 55.53 54.75 51.95 61.78 48.05 57.5 53.28 62.41 49.75 71.09 51.01 75.52 53.96 82.24 65.98 86.23 67 92.56 65.14 95.57 68.8 98.91 67.21 101.63 69.75 115.63 59.84 132.53 60.08 147.9 55.9 145.68 66.98 151.69 68.8 156.1 66.97 158.52 70.01 164.81 66.61 169.32 76.56 167.18 78.14 173.54 80.49 172.84 82.39 177.44 85.82 177.1 87.44 162 86.1 159.91 87.03 156.4 84.52 154.39 92.39 146.42 85.88 132.57 82.78 129.32 87.35 122.39 87.99 121.79 89.81 112.66 88.82 109.72 94.36 105.13 96.37 102.39 102.4 99.91 99.8 102.26 95.45 104.06 95.61 104.52 91.62 98.14 92.24 95.94 97.49 92.95 99.09 92.43 89.89 89.38 98.63 74.92 119.14 74.98 121.83 71.32 118.32 73.25 110.98 67.35 110.94 69.83 98.8 61.47 94.02 61.25 88.96 50.21 84.94 41.78 84.25 34.22 79.53 7.29 70.7 4.59 63.93 0 61.85 17.05 51.88 27.82 51.05 35.25 45.75 39.63 45.41 48.27 37.09 48.79 40.53 49.36 41.16 52.02 42.19 51.65 44.73"
  }), React.createElement("polygon", {
    points: "73.39 30.13 65.62 31.4 67.41 33.04 60.14 38.24 54.26 46.97 52.75 44.01 54.42 42.3 55.17 38.93 54.05 42.12 49.22 40.48 49.7 37.11 58.56 29.56 70.99 28.04 73.39 30.13"
  }), React.createElement("polygon", {
    points: "53.57 0.46 54.91 0 49.93 5.75 40.05 10.56 42.39 10.92 34.38 12.15 36.95 8.03 53.57 0.46"
  }));
});

var MN = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.07 256"
  }, React.createElement("polygon", {
    points: "55.8 20.43 64.11 16.8 68.28 21.74 71.9 21.94 72.12 25.13 75.2 27.97 95.86 32.2 99.22 37.45 106.89 36.37 108.07 33.98 113.67 32.56 122.4 33.35 131.29 36.63 129.7 40.6 135.89 41.09 139.42 50.23 141.76 49.03 142 45.45 148.12 44.72 150.95 49.48 157.72 51.85 158.58 54.78 162.77 57.48 171.47 56.58 183 48.88 186.79 55.32 205.11 53.32 211.17 58.66 215.19 57.19 221.07 57.84 186.22 75.75 165.48 97.79 148.3 111.93 144.77 118.09 142.49 118.29 142.73 143.39 130.29 150.91 124.63 160.05 124.88 165.6 128.94 166.33 131.66 172.1 128.73 178.35 129.06 185.19 127.44 187.31 128.83 193.93 126.95 201.26 134.3 207.76 140.26 208.95 143.66 213.66 149.41 215.07 163.44 230.71 171.52 233.16 175.52 238.11 177.01 255.4 94.36 256 11.75 253.82 15.14 175.56 11.86 171.19 7.57 169.77 3.21 161.74 12.09 151.77 13.43 137.34 7.46 116.53 9.1 104.46 7.21 100.82 7.65 74.69 1.03 51.21 0.93 33.7 2.81 28.72 0 13.64 54.8 15.88 55.8 20.43"
  }), React.createElement("polygon", {
    points: "60.53 0 64.97 0.9 66.08 3.18 64.8 7.44 60.57 9.16 60.53 0"
  }));
});

var MO = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 236.42"
  }, React.createElement("polygon", {
    points: "164.87 16.86 161.8 27.05 164.31 42.54 167.86 50.31 190.22 72.02 192.96 86.2 195.92 91.45 199.22 91.27 203.65 87.61 215.42 94.43 205.66 119.06 206.31 124.61 216.23 135.07 223.69 138.23 239.63 151.77 239.7 158.62 243.04 165.74 239.84 172.28 245.8 183.25 249.92 185.53 248.52 182.02 250.47 181.4 253.42 186.48 256 186.49 255.79 197.42 252.15 206.48 246.33 203.93 242.05 213 241.03 207.92 238.34 207.84 239.99 216.46 236.07 218.6 238.97 221.91 233.43 223.34 236.75 228.57 232.35 235.66 205.75 236.42 209.04 230.15 218.34 221.42 218.44 217.07 214.48 210.82 34.78 207.3 40.86 74.72 32.57 71.1 30.25 62.57 22.49 53.91 28.43 44.77 32.08 44.78 31.99 40.82 29.65 36.68 24.04 38.43 12.3 29.14 10.6 18.79 3.82 14.74 2.66 4.27 0 2.59 0.18 0 66.88 4.61 154 4.77 164.87 16.86"
  }));
});

var MS = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.88 256"
  }, React.createElement("polygon", {
    points: "124.2 254.79 122.98 254.96 124.89 254.59 124.2 254.79"
  }), React.createElement("polygon", {
    points: "147.98 254.63 146.03 254.92 144.49 254.24 147.98 254.63"
  }), React.createElement("polygon", {
    points: "118.58 253.56 117.66 255.73 114.49 253.91 118.9 252.44 118.58 253.56"
  }), React.createElement("polygon", {
    points: "142.49 254.43 132.81 253.18 132.81 252.84 135.5 252.44 142.49 254.43"
  }), React.createElement("polygon", {
    points: "150.2 0.54 157.87 0.5 161.88 5.24 144.99 165.75 148.87 247.02 145.97 248.92 140.06 245.15 133.46 247.34 124.92 242.66 122.4 243.71 128.06 244.47 110.5 249.08 106.29 246.06 105.19 247.48 106.8 249.52 102.16 252.38 101.15 255.99 95.5 256 90.4 241.74 84.84 235.9 82.75 229.69 87.98 212.86 0 211.38 3.66 208.5 0.8 196.97 6.27 195.94 7.93 189.72 6.53 184.93 10.87 181.18 15.04 167.04 27.02 158.09 26.98 151.32 29.84 151.05 35.56 141.77 26.9 134.1 27.29 128.7 24.36 124.51 28.75 121.07 24.91 117.8 28.91 109.79 24.67 106.59 25.14 99.31 28.25 96.78 27.49 90.78 24.45 88.59 27.09 80.24 22.38 75.41 25.91 74.39 26.18 71.96 22.81 69.36 31.11 62.43 30.13 58.73 31.68 56.28 29.2 53.08 38.71 49.48 35.46 44.3 39.56 41.77 41.55 37.59 43.77 37.72 44.37 32.59 47.61 33.09 51.7 30.36 53.12 14.71 57.07 13.84 57.78 9.04 66.27 4.12 64.91 0 150.2 0.54"
  }));
});

var MT = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 147.11"
  }, React.createElement("polygon", {
    points: "253.81 96.01 256 125.13 179.55 128.84 101.86 129.05 101.53 144.63 94.53 136.5 91.81 139.87 92.48 142.83 75.18 141.69 71.77 144.99 63.79 143.73 61.72 147.11 58.34 144.22 55.56 134.43 49.25 131.43 49.44 126.5 43.82 117.29 42.41 107.94 38.53 104.77 31.43 111.14 26.22 108.03 26.55 101.51 30.27 98.5 28.32 89.93 33.13 74.57 27.94 74.88 26.11 71.52 23.96 72.38 13.09 54.56 5.32 48.44 7.19 47.42 5.43 44.91 6.07 40.48 0 30.53 2.63 0 125.78 5.66 247.03 1.74 253.81 96.01"
  }));
});

var NC = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 98"
  }, React.createElement("polygon", {
    points: "185.09 95.56 184.29 98 183.05 97.39 183.1 96.46 185.09 95.56"
  }), React.createElement("polygon", {
    points: "188.59 86.53 187.41 89.08 187 89.52 187.85 86.74 188.59 86.53"
  }), React.createElement("polygon", {
    points: "202.02 74.03 197.34 76.52 193.9 79.78 195.48 77.54 199.2 75.02 202.02 74.03"
  }), React.createElement("polygon", {
    points: "225.63 69.33 225.23 69.53 222.19 67.68 224.8 68.34 225.63 69.33"
  }), React.createElement("polygon", {
    points: "221.4 67.22 217.16 67.39 209.29 69.42 215.13 67.6 219.88 66.81 221.4 67.22"
  }), React.createElement("polygon", {
    points: "226.18 70.24 229.27 63.88 235.08 58.43 229.61 64.11 226.18 70.24"
  }), React.createElement("polygon", {
    points: "236.81 56.7 238.54 53.87 239.73 54.19 237.23 56.02 236.81 56.7"
  }), React.createElement("polygon", {
    points: "243.39 51.44 240.29 53.7 241.03 51.97 247.29 49.15 243.39 51.44"
  }), React.createElement("polygon", {
    points: "253.79 47.69 248.3 49.48 254.5 45.63 255.54 35.95 253.88 28.41 256 35.32 255.18 44.01 253.79 47.69"
  }), React.createElement("polygon", {
    points: "250.72 26.79 249.74 26.61 247.82 22.83 249.59 23.5 250.72 26.79"
  }), React.createElement("polygon", {
    points: "245.38 9.64 247.82 16.34 253.67 27.94 247.82 20.55 248.92 19.57 244.66 10.56 242.62 1.74 245.38 9.64"
  }), React.createElement("polygon", {
    points: "240.17 1.8 241.81 1.76 242.09 3.63 240.05 3.56 238.85 1.82 240.17 1.8"
  }), React.createElement("polygon", {
    points: "121.03 3.17 238.33 1.84 238.48 4.29 240.25 5.92 240.13 7.03 241.48 8.31 241.67 5.99 245.85 18.09 240.57 10.33 242.26 15.28 233.81 9.98 237.83 15.52 234.88 16.7 231.27 13.91 233.43 17.84 226.4 14.29 230.82 18.04 223.31 21.17 220.13 19.71 218.81 15.32 220.16 11.57 218.69 10.36 218.07 17.26 220.12 21.45 219 23.64 227.82 22.15 232.35 24.02 231.72 22.34 238.45 21.77 238.42 28.47 236.47 28.49 239.07 31.78 236.09 31.87 239.29 33.46 240.22 25.13 241.75 23.74 243.9 25.23 242.51 23.24 244.89 23.41 244.04 21.73 247.96 26.91 247.68 33.84 244.89 36.19 243.46 33.81 239.61 41.6 236.17 44.24 230.21 42.07 229.75 44.56 228.35 40.32 226.11 42.96 223.81 39.28 226.99 37.66 221.72 38.51 223.19 42.9 210.07 38.28 212.31 41.63 227.02 47.18 221.2 50.84 224.18 50.51 224.55 52.39 218.77 57.28 209.54 51.57 213.68 57.72 219.04 60.06 222.6 57.27 225.32 59.14 224.43 57 226.73 57.68 227.68 54.1 227.57 58.78 231.49 57.44 230.63 55.65 233.1 57.77 226.27 66.07 223.21 63.27 222.81 67.04 221.22 63.85 218.77 65.57 220.79 66.51 215.15 66.15 209.46 68.46 208.29 65.48 208.19 68.29 203 72.54 200.56 71.71 202.51 69.54 199.47 65.94 201.09 70.19 199.14 71.03 201.25 73.88 196.71 76.01 191.11 81.46 185.08 95.09 185.61 88.81 184.38 85.92 184.84 92.54 182.45 96.46 172.39 94.47 167 97.38 135.1 64.75 102.32 63.23 102.14 58.51 98.18 53.13 94.91 54.75 94.52 51.66 56.19 48.28 35.53 55.16 0 53.96 1.44 45.48 7.63 44.45 9.83 39.06 13.51 36.15 24.79 34.66 34.5 28.53 39.7 27.77 42.3 22.16 45.07 22.71 50.39 18.54 52.27 21.98 62.4 15.37 66.47 17.27 71.71 10.11 76.74 9.31 78.63 0 121.03 3.17"
  }));
});

var ND = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 152.15"
  }, React.createElement("polygon", {
    points: "256 148.71 128.59 152.15 0 149.37 6.8 0 115.61 2.63 226.77 0.39 231.53 16.98 229.96 22.76 231.97 42.37 241.91 67.95 244.24 97.26 246.74 101.13 246.21 114.83 253.5 130.09 256 148.71"
  }));
});

var NE = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 117.56"
  }, React.createElement("polygon", {
    points: "217.64 19.16 220.09 19.88 222.18 31.91 230.79 46.33 230.71 55.78 233.46 56.26 233.18 58.34 235.42 59.22 234.67 63.72 237.27 64.73 235.84 68.06 238.01 69.81 238.37 86.96 243.82 94.78 245.58 102.66 250.75 104.77 252.89 112.5 256 114.06 157.06 117.56 57.26 117.13 58.16 78.78 0 76.68 3.67 0 81.11 2.44 160.49 2.35 174.15 10.36 178.82 6.89 194.69 5.95 199 9.44 211.34 13.5 213.47 18.39 217.64 19.16"
  }));
});

var NH = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.36 256"
  }, React.createElement("polygon", {
    points: "104.94 5.27 114.94 171.28 113.72 187.78 124.97 202.17 124.83 210.59 130.75 218.17 130.03 220.6 133.27 219.96 133.36 221.92 125.9 238.52 117.84 237.69 107.17 244.38 102.31 244.74 98.35 251.04 91.12 256 6.28 253.11 0.35 242.86 0 238.43 2.52 228.86 6.23 225.93 8.8 201.65 11.34 197.02 12.41 171.71 16.67 166.26 18.65 155.8 25.3 149.5 27.7 139.66 33.45 130.99 32.23 128.27 36.76 118.1 37.73 100.69 41.91 95.05 50.66 94.24 63.46 84.58 69.07 77.79 69.41 72.42 72.5 70.76 66.48 55.65 74.89 40.42 73.68 30.1 82.3 9.89 79.34 7.75 88.87 1.09 99.39 5.79 104.63 0 104.94 5.27"
  }));
});

var NJ = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.31 256"
  }, React.createElement("polygon", {
    points: "97.78 205.94 92.37 206.78 90.51 204.03 94.47 206.18 97.81 201.13 97.09 199.25 102.43 199.26 97.78 205.94"
  }), React.createElement("polygon", {
    points: "108.05 190.6 106.13 193.18 118.89 168.52 115.15 179.21 108.05 190.6"
  }), React.createElement("polygon", {
    points: "126.34 57.67 124 66.52 116.04 72.52 117.09 67.15 111.11 73.99 105.64 84.81 104.86 92.81 109.76 96.15 116.68 95.87 126.93 100.31 128.36 99.91 127.16 93.38 129.06 97.5 130.1 111.77 123.09 133.18 125.38 138.62 120.94 164.03 119.76 166.36 123.15 141.42 121.72 136.21 121.34 140.7 116.79 143.07 118.41 145.84 115.96 149.77 119.39 151.25 112.69 166.2 114.3 172.97 101.32 188.97 102.8 194.64 97.77 190.27 93.82 189.57 95.77 198.62 94.74 201.14 90.5 201.15 88.84 206.19 91.65 206.64 93.37 210.63 83.83 215.55 87.78 209.85 85.5 208.35 82.16 215.56 74.68 215.97 73.16 217.78 82.16 218.5 74.59 225.76 69.81 235.18 66.44 235.83 69.24 237.99 62.68 244.16 61.43 249.58 55.51 254.11 48.96 256 49.84 245.64 53.97 236.92 53.01 229.33 43.51 228.29 42.04 225.62 33.32 228.47 31.66 223.49 25.55 217.31 20.52 216.15 18.27 211.83 15.35 211.96 2.04 197.59 1.27 194.32 2.68 195.81 3.84 189 0 183.29 12.56 163.44 20.33 159.25 33.89 156 37.6 152.69 36.22 147.82 39.23 147.73 50.86 135.49 64.3 129.24 67.64 125.73 49.99 105.06 47.85 99.2 42.91 99.12 38.72 84.01 31.22 82.7 30.81 62.87 33.08 59.52 37.51 59 41.38 50.93 34.88 39.32 43.9 32.55 51.01 24.06 58.49 8.76 63.63 2.98 70.08 0 133.31 38.26 132.49 44.51 126.34 57.67"
  }));
});

var NM = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.97 256"
  }, React.createElement("polygon", {
    points: "96.53 236.05 98.76 238.46 32.77 235.79 32.06 256 0 254.75 11.82 0 120.68 3.67 229.5 3.87 229.97 228.13 92.53 227.52 96.53 236.05"
  }));
});

var NV = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.19 256"
  }, React.createElement("polygon", {
    points: "169.19 213.32 167.56 218.13 165.1 218.99 160.41 214.57 154.86 214.15 150 216.65 151.77 237.44 154.71 248.43 153.11 256 0 108.62 5.43 0 86 2.75 166.3 2.68 169.19 213.32"
  }));
});

var NY = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 194.49"
  }, React.createElement("polygon", {
    points: "183.91 188.52 183.81 190.77 178.26 194.49 180.24 188.76 183.91 188.52"
  }), React.createElement("polygon", {
    points: "210.72 187.46 206.12 189.42 200.63 189.93 207.66 187.84 210.72 187.46"
  }), React.createElement("polygon", {
    points: "214.07 188.13 209.71 188.89 209.5 188.36 226.44 182.5 214.07 188.13"
  }), React.createElement("polygon", {
    points: "243.2 166.36 231.06 176.46 236.54 176.24 240.86 170.72 245.29 171.72 245.82 169.6 247.85 172.03 256 168.78 227.65 182.49 230.22 180.8 195.85 189.97 199.92 190.52 188.19 191.8 193.84 189.68 191.47 187.9 189.32 188.82 189.89 190.45 185.74 191.23 184.83 188.25 188.22 182.8 193.8 182.28 194.01 180.19 195.36 181.39 195.56 178.41 197.84 180.48 198.49 176.96 203.15 177.66 204.03 175.22 207.01 177.15 205.57 175.11 211.39 176.76 215 173.89 230.87 173.19 240.04 166.21 243.2 166.36"
  }), React.createElement("polygon", {
    points: "250.85 160.92 249.92 160.03 253.04 159.35 251.33 160.7 250.85 160.92"
  }), React.createElement("polygon", {
    points: "29.85 81.3 28.06 83.82 26.31 82.25 26.78 79.9 29.85 81.3"
  }), React.createElement("polygon", {
    points: "115.5 43.08 114.36 43.94 116.44 41.11 115.92 42.55 115.5 43.08"
  }), React.createElement("polygon", {
    points: "121.08 29.54 121.28 30.13 118.36 31.43 118.84 30.08 121.08 29.54"
  }), React.createElement("polygon", {
    points: "125.88 27.13 124.78 28.55 122.34 30.16 121.74 28.38 125.88 27.13"
  }), React.createElement("polygon", {
    points: "159.51 0.01 205.16 0 205.63 2.14 204.57 16.71 207.25 24.19 206.4 32.98 202.94 40.9 205.42 52.99 203.57 60.47 204.17 62.04 207.22 59.59 209.19 62.78 209.44 97.39 201.64 126.53 200.74 160.43 202.75 163.74 194.99 168.75 197.48 173.54 192.16 178.8 192.67 180.81 188.39 181.43 185.92 185.57 190.13 171.79 187.63 159.81 186.41 161.61 189 173.65 163.14 157.87 161.77 154.62 153.9 151.68 151.44 147.03 150.94 137.4 145.47 135 142.63 130 0 124.52 0.74 112.91 20.98 100.75 25.3 95.05 30.26 92.43 28.96 83.74 30.66 80.71 25.16 78.04 25.79 70.61 47.48 66.64 67.3 69.75 72.38 73.75 79.28 72.24 92.18 74.45 93.07 72.59 99.97 71.14 109.44 62.95 114.23 63.19 116.77 60.85 117.47 57.33 116.14 58.18 113.43 49.01 115.79 47.22 116.16 49 121.23 43.09 116.59 43.67 119.14 40.48 116.57 39.27 113.57 41.45 112.02 37.17 127.93 26.72 132.81 18.12 146.22 6.11 159.51 0.01"
  }));
});

var OH = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237.12 256"
  }, React.createElement("polygon", {
    points: "237.12 95.56 228.68 99.88 232.75 107.15 231.61 114.29 233.25 118.76 226.23 136.3 225.17 147.08 222.79 147.44 223.16 151.46 219.2 158.5 221.22 162.1 219.16 168.68 199.97 185.46 192.15 188.96 189.23 185.05 186.87 185.06 181.86 189.57 180.43 194.51 174.8 194.87 170.9 201.58 170.9 206.75 167.35 208.6 169.68 211.78 170.47 218.77 167.1 217.57 162.82 223.33 160.77 215.02 157.1 212.82 154.02 214.16 145.68 229.72 147.48 242.17 141.89 243.87 138.85 254.22 124.38 256 118.26 247.65 111.06 243.98 107.1 232.16 99.65 234.67 92.85 241.56 84.22 242.73 80.69 238.53 71.46 235.02 66.84 236.72 64.87 240.04 61.31 239.82 52.95 230.85 47.01 228.82 40.76 229.53 33.35 226.13 28.64 212.2 19.93 205.25 10.34 207.47 5.29 202.41 0 205.77 6.43 19.88 77.71 18.49 97.45 27.16 103.11 32.6 108.74 33.17 110.84 29.23 118.73 34.57 99.2 38.44 106.5 40.59 113.92 37.49 123.52 40.97 119.46 36.13 126.89 42.14 131.64 43.41 154.06 34.96 170.06 35.81 191.03 19.01 234.95 0 237.12 95.56"
  }));
});

var OK = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 124.86"
  }, React.createElement("polygon", {
    points: "248.23 20.39 255.04 61.03 256 124.86 243.94 121.28 240.96 117.73 233.07 114.01 228.99 117.6 224.69 117.46 221.53 114.72 215.95 118.4 211.19 117.03 200.51 122.1 199.35 124.37 191.51 119.47 190.9 117.05 186.4 119.17 180.72 115.25 176.39 118.81 174.32 123.84 172.19 117.07 165.34 120.17 159.06 114.05 152.97 118.71 150.32 118.52 149.42 114.04 145.37 112.84 144.82 108.37 137.59 108.58 133.09 111.07 130.19 108.05 126.09 108.77 112.22 105.55 111.77 101.82 106.66 96.61 104.97 99.59 97.5 99.13 90.65 92.37 87.39 92.12 88.75 21.52 0 18.31 0.93 0 125.18 3.7 247.6 2.05 248.23 20.39"
  }));
});

var OR = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 187.87"
  }, React.createElement("polygon", {
    points: "49.84 2.89 52.37 2.78 58.89 7.84 63.04 26.56 77.15 30.54 91.71 24 107.73 24.76 111.3 28.59 119.16 27.79 127.77 23.9 139.81 23.62 159.85 15.09 174.61 13.95 177.36 11.67 242.35 9.53 246.34 16.54 253.15 19.54 256 27.34 245.76 52.32 245.71 57.77 240.15 65.38 234.93 80.5 236.28 85.28 242.78 85.73 245.53 89.64 243.25 93.11 244.47 96.7 241.78 105.11 245.72 185.41 130.71 187.87 9.54 185.06 5.22 179.93 2.85 169.98 4.67 156.38 0 147.87 4.88 138.99 7.41 126.02 9.04 125.01 9.75 127.93 12.12 122.31 14.96 124.84 13.65 119.95 9.28 123.98 13.19 112.96 15.48 109.56 17.66 110.4 15.8 108.79 13.91 110.56 17.52 83.89 19.07 78.93 20.75 79.53 18.62 77.31 19.83 70.61 21.55 70.53 19.98 69.63 20.05 61.25 23.63 46.95 23.04 38.53 25.75 35.43 24.19 33.85 25.07 29.26 25.67 32.38 27.64 31.99 24.83 28.41 27.73 23.19 25.57 24.43 24.17 20.31 24.51 12.49 26.79 8.23 24.89 0 30.15 3.06 30.68 5.51 31.38 3.74 29.14 1.79 31.81 0.99 33.68 2.53 40.1 0.15 42.99 3.86 46.22 4.57 49.84 2.89"
  }));
});

var PA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 146.66"
  }, React.createElement("polygon", {
    points: "254.89 51.09 251.44 52.84 244.97 64.57 236.92 72.27 240.24 79.39 238.29 83.86 234.72 86.09 234.41 89.44 235.32 96.89 239.44 97.46 242.01 105.61 244.71 105.56 256 119.63 239.1 131.04 237.99 135.19 225.86 141.03 218.02 139.46 213.6 141.64 210.39 146.35 194.69 146.66 0 145.36 4.12 15.43 17.56 9.61 22.87 5.06 20.83 7.78 36.95 0 36.59 15.43 226.18 15.14 229.51 17.88 230.22 21.64 237.62 24.54 238.78 37.3 242.28 43.34 252.9 46.84 254.89 51.09"
  }));
});

var PR = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 62.52"
  }, React.createElement("polygon", {
    points: "194.91 56.97 194.78 56.97 194.78 56.85 194.91 56.97"
  }), React.createElement("path", {
    d: "M-9.77,50.53-8.7,49l-1.52-3.47-.77-.14h5.93l-3.78-4.67-1.81-.45L-14,34.07l5.16-1.91,3.58-2.29.71.34-.62-.39,2-1.86-1.28-4,.25-1.87,2.69-2.36L2.24,19l7.15.42,4,1.93,6.68.82,3.69-.84,3.61.51,4-.57L35.16,23l3.35.32,3.34-1.73,4.48-.44,4,1,3-.49.07.15.75.36.91.28-.21.18.09.1,1.63-.33.82,1.26-.08-1,2.67.78,7.68-2.3,1.64,1,.26-.57,3.77.38,4.7,1.37,1.67-.85,2.79,1.18,3.54.21L88.3,23l-.41,1.6,2,.84,2.39-1.58L91.94,23l1,.35-1,.93,1.08,1-1-.56.11.68,1.2.89,1.26-.25.3,1.64,2.45-1.32-2.24-1.82,1.66.15,0-.17L95.1,24l-1,.58-.79-1.3L101.4,25l1.47,1.05,1.83-.18,1-1.2.54.89-.59.37.44-.14.2.84,1,.51-.06-.94-.82-.15-.59-1.65L112,26l2-.8,2.39,1.47,4.11.62,1.75,2.14,2.39-1.13-.83,1.35.28.32,0,.1.07.07,2.11-1.08,0,1.28,2.33,1.81,2.37-.69.82,1.62,1.29.5L137,34l1.32-1.71,2.38-.69.13,1.48h4.5L150,35.69,140.2,41.5l.08,1L142,44.12l-.55.56.78,1.8,1.18.85-.65,1.93-2.6-.41-.3-2.2-1.42,1.89,1-.09.12,1.62-3.06-.62-2.7,2.88-2.95-1-1.37,1.47,1,1.46-.41.48-1.6.24V54l-1.8,1.42L124.92,61l-1.29,1.27.61.4-.44,1.23-.87.43-.87-.64-1.43,1.5,0,3.55-1-.41-1.27,1.09-1.2-.14-1.34,1.85-1.08-.27-2.09,1.49-5.72.76-2.33-1.67-4.08,3.16-1.91-1.37-1.73.2-6.81,3.54.47-1.36-.55,1-2.86-.67-.84.89-.66-.27-.32,0-.93-1.42,1.33-.69-.06-1-2.75,1.75.45.18,0,1.24-.65-1.29-.94.49.2.84-2.27-1.63L78,75.58l-.17-1.92-.66.22L74.81,72l-3.75,1,.26.68-.91,0,0,1-.61-.43L69,75.87l0-.29-1.64-1-2.28-.65.1-.83-.24.87L61.8,70.81l-6.25.77-4.83,2.06-.09-.29-.28-.15-.07.37-.67-.77-.71.25.2-1.84L48.8,73l-.56,0-.37.52-.79.1-.42-2L42,73.16l-4.11-2.34-2,0,0-.14-.13-.62-.31.77-.42-.72-.93,2.08-.54-.86,1.16-1.08-.56.41-.63-.32.78-.32-1.93.62-1.1,1.87L28,74.34l-3.28.6.1-.8-.64,1.11-.8-.73-.61.49-3.89.24-.38,1.8-3.13-.39.17-.73-2.33-1.31-.13-.91-2,0L9,72.58l-3.55-.31-1.25.31.35,0L4.12,74l-1-.68-.84.83.34.55-1,.53-.94-.71-1,.62-3.17-.7-.28-.83-1.58-.25-1.27,1.29.85,2-1.06-.16-2.27-2.61-.26-3.81,4.6-1.66-.18-1L-8.3,66.35l1.05-1.15-.06-4.31,1.54-1.3-.34-3,.93-1.63L-6,53.63l.47-.33-4.27-2.77M101.44,28.32l-.06-.57,1.39,1.31,2.18.31-.68-.3.82-.26-1.15-.08,1.13-.83-1.34,0,.23-1.6-.27,1.53-2-1.92-.7.13.86.81-.5.73-3.45-1.21-.49.18,3.89,1.07.13.66m0,0,0,.06,0,0,0-.06v0m38.73,11.53h0v0h0v0m-146,16.63.12,1.25h.53l.4-1-.49-.67-.56.42M17.88,33.19l.08,0,.45-.08.18-.39.23.66.93-.33,0,1.25,1.1-.54-2.06-1.35-.15-1.35-.8,2.1M93.47,29l0,.12.23-.08h0l-.2,0m11.08-1.81h.52v0h-.52m-8.77.88h0l.07-.15h0l-.08.14m1.58.13v0h0M96,27.75l-.07.17.79.17L96,27.7Z",
    transform: "translate(78 -19)"
  }), React.createElement("polygon", {
    points: "3.31 44.64 0.76 42.81 2.04 39.71 4.12 39.07 6.28 39.77 8.67 38.83 9.87 39.97 10.31 42.61 7.76 45.16 5.45 45.71 3.31 44.64"
  }), React.createElement("polygon", {
    points: "0 35.57 0.15 35.31 0.45 35.59 0.38 35.66 0 35.57"
  }), React.createElement("polygon", {
    points: "131.51 2.71 131.49 2.72 131.48 2.71 131.49 2.71 131.51 2.71"
  }), React.createElement("polygon", {
    points: "241.61 19.17 241.27 19.03 241.04 18.69 241.55 18.74 241.61 19.17"
  }), React.createElement("polygon", {
    points: "241.61 19.17 241.62 19.15 241.62 19.16 241.61 19.17"
  }), React.createElement("polygon", {
    points: "232.87 41.64 230.65 41.43 225.97 42.87 223.37 41.82 222.59 39.1 228.34 38.2 228.62 35.98 229.16 37.72 234.7 36.45 235.75 35.31 239.36 34.83 248.25 36.94 249.7 36.24 251.66 37.62 249 38.3 247.97 37.51 247.78 38.41 246.32 38.43 245.96 38.98 244.63 39.75 244.65 39.89 241.61 39.55 240.73 40.47 239.09 39.89 235.73 41.85 235.47 40.58 234.67 40.56 235.43 41.31 234.5 42.34 233.84 41.39 232.87 41.64"
  }), React.createElement("polygon", {
    points: "248.47 38.74 248.53 38.7 248.57 38.71 248.44 38.76 248.47 38.74"
  }), React.createElement("polygon", {
    points: "241.2 40.28 241.23 40.22 241.26 40.21 241.23 40.3 241.2 40.28"
  }), React.createElement("polygon", {
    points: "244.87 39.72 244.9 39.64 244.97 39.74 244.91 39.71 244.87 39.72"
  }), React.createElement("polygon", {
    points: "247.81 38.84 247.84 38.73 247.9 38.75 247.9 38.9 247.81 38.84"
  }), React.createElement("polygon", {
    points: "112.83 54.2 112.61 54.31 112.49 54.13 112.82 54.18 112.83 54.2"
  }), React.createElement("polygon", {
    points: "128.31 54.6 128.43 54.39 128.53 54.39 128.54 54.63 128.31 54.6"
  }), React.createElement("polygon", {
    points: "91.09 55.65 91.06 55.61 91.07 55.54 91.12 55.63 91.09 55.65"
  }), React.createElement("polygon", {
    points: "90.98 55.9 90.98 55.89 91.02 55.91 91 55.91 90.98 55.9"
  }), React.createElement("polygon", {
    points: "91.14 55.98 91.14 55.97 91.16 55.96 91.15 55.99 91.14 55.98"
  }), React.createElement("polygon", {
    points: "91.16 56 91.17 55.98 91.18 55.98 91.18 56 91.16 56"
  }), React.createElement("rect", {
    x: "97.56",
    y: "56.17",
    width: "0.02",
    height: "0.02"
  }), React.createElement("polygon", {
    points: "91.39 56.13 91.4 56.09 91.43 56.09 91.43 56.12 91.39 56.13"
  }), React.createElement("polygon", {
    points: "97.59 56.16 97.61 56.14 97.64 56.16 97.62 56.19 97.59 56.16"
  }), React.createElement("polygon", {
    points: "91.18 56.03 91.19 56 91.22 56 91.2 56.05 91.18 56.03"
  }), React.createElement("polygon", {
    points: "91.91 57.78 91.93 57.77 91.98 57.79 91.95 57.8 91.91 57.78"
  }), React.createElement("polygon", {
    points: "91.09 56 91.1 55.94 91.12 55.95 91.12 56 91.09 56"
  }), React.createElement("polygon", {
    points: "97.63 56.13 97.66 56.09 97.7 56.09 97.67 56.14 97.63 56.13"
  }), React.createElement("polygon", {
    points: "91.29 56.11 91.35 56.07 91.38 56.12 91.36 56.13 91.29 56.11"
  }), React.createElement("polygon", {
    points: "101.35 56.39 101.51 56.36 101.61 56.45 101.39 56.42 101.35 56.39"
  }), React.createElement("polygon", {
    points: "91.92 56.3 92.15 56.35 92.17 56.42 92.02 56.43 91.92 56.3"
  }), React.createElement("polygon", {
    points: "101.63 56.36 101.84 56.07 101.94 56.13 101.91 56.37 101.63 56.36"
  }), React.createElement("polygon", {
    points: "101.08 56.63 101.21 56.49 101.53 56.5 101.35 56.7 101.08 56.63"
  }), React.createElement("rect", {
    x: "12.8",
    y: "74.85",
    width: "0.01",
    height: "0.01",
    transform: "translate(18.13 33.83) rotate(-63.43)"
  }), React.createElement("polygon", {
    points: "83.25 54.24 83.26 54.22 83.28 54.22 83.27 54.25 83.25 54.24"
  }), React.createElement("polygon", {
    points: "82.48 55.05 82.49 55.02 82.52 55.03 82.51 55.06 82.48 55.05"
  }), React.createElement("polygon", {
    points: "83.11 54.17 83.14 54.16 83.15 54.18 83.14 54.19 83.11 54.17"
  }), React.createElement("polygon", {
    points: "91.01 55.49 91.01 55.46 91.04 55.45 91.03 55.49 91.01 55.49"
  }), React.createElement("polygon", {
    points: "85.11 55.44 85.14 55.45 85.14 55.47 85.12 55.47 85.11 55.44"
  }), React.createElement("polygon", {
    points: "85.6 54.83 85.62 54.81 85.66 54.8 85.63 54.83 85.6 54.83"
  }), React.createElement("polygon", {
    points: "90.44 55.8 90.48 55.78 90.5 55.8 90.47 55.83 90.44 55.8"
  }), React.createElement("polygon", {
    points: "86.04 54.57 86.07 54.53 86.09 54.53 86.07 54.59 86.04 54.57"
  }), React.createElement("polygon", {
    points: "83.32 54.29 83.34 54.26 83.37 54.27 83.35 54.3 83.32 54.29"
  }), React.createElement("polygon", {
    points: "82.73 54.56 82.76 54.54 82.77 54.6 82.75 54.59 82.73 54.56"
  }), React.createElement("polygon", {
    points: "80.73 54.79 80.76 54.77 80.78 54.77 80.75 54.82 80.73 54.79"
  }), React.createElement("polygon", {
    points: "86.23 54.43 86.25 54.41 86.3 54.45 86.27 54.46 86.23 54.43"
  }), React.createElement("polygon", {
    points: "85.95 54.65 85.98 54.63 86.02 54.67 85.99 54.68 85.95 54.65"
  }), React.createElement("polygon", {
    points: "81.22 54.7 81.25 54.7 81.29 54.74 81.25 54.74 81.22 54.7"
  }), React.createElement("polygon", {
    points: "90.73 55.8 90.78 55.81 90.78 55.85 90.73 55.83 90.73 55.8"
  }), React.createElement("polygon", {
    points: "90.96 55.38 90.97 55.34 91.01 55.32 91 55.38 90.96 55.38"
  }), React.createElement("polygon", {
    points: "90.83 55.88 90.87 55.86 90.94 55.92 90.9 55.92 90.83 55.88"
  }), React.createElement("polygon", {
    points: "84.95 55.46 85.01 55.42 85.05 55.45 85.03 55.48 84.95 55.46"
  }), React.createElement("polygon", {
    points: "85.93 53.73 85.99 53.7 86.01 53.73 85.97 53.76 85.93 53.73"
  }), React.createElement("polygon", {
    points: "84.74 54.2 84.78 54.18 84.81 54.26 84.76 54.25 84.74 54.2"
  }), React.createElement("polygon", {
    points: "85.69 54.79 85.84 54.77 85.86 54.8 85.79 54.82 85.69 54.79"
  }), React.createElement("polygon", {
    points: "90.59 55.78 90.64 55.76 90.7 55.82 90.67 55.83 90.59 55.78"
  }), React.createElement("polygon", {
    points: "84.81 53.74 84.87 53.73 84.91 53.78 84.85 53.78 84.81 53.74"
  }), React.createElement("polygon", {
    points: "85.61 53.71 85.64 53.68 85.69 53.71 85.63 53.75 85.61 53.71"
  }), React.createElement("polygon", {
    points: "82.69 54.38 82.73 54.34 82.77 54.37 82.72 54.43 82.69 54.38"
  }), React.createElement("polygon", {
    points: "81.31 54.72 81.42 54.68 81.44 54.73 81.37 54.76 81.31 54.72"
  }), React.createElement("polygon", {
    points: "87.22 53.96 87.24 53.91 87.38 53.98 87.24 53.98 87.22 53.96"
  }), React.createElement("polygon", {
    points: "82.84 53.59 82.89 53.5 82.95 53.5 82.92 53.57 82.84 53.59"
  }), React.createElement("polygon", {
    points: "88.44 54.61 88.5 54.62 88.56 54.75 88.47 54.7 88.44 54.61"
  }), React.createElement("polygon", {
    points: "83.57 53.64 83.65 53.61 83.68 53.7 83.62 53.71 83.57 53.64"
  }), React.createElement("polygon", {
    points: "83.3 53.46 83.35 53.41 83.4 53.5 83.34 53.52 83.3 53.46"
  }), React.createElement("polygon", {
    points: "80.68 54.85 80.75 54.86 80.72 55.01 80.67 54.95 80.68 54.85"
  }), React.createElement("polygon", {
    points: "83.43 53.45 83.5 53.34 83.58 53.34 83.49 53.46 83.43 53.45"
  }), React.createElement("polygon", {
    points: "83.72 53.46 83.75 53.41 83.91 53.42 83.9 53.46 83.72 53.46"
  }), React.createElement("polygon", {
    points: "81.19 54.53 81.25 54.45 81.35 54.52 81.29 54.6 81.19 54.53"
  }), React.createElement("polygon", {
    points: "82.77 53.67 82.98 53.59 83.03 53.63 82.84 53.72 82.77 53.67"
  }), React.createElement("polygon", {
    points: "83.05 53.58 83.11 53.37 83.2 53.39 83.23 53.55 83.05 53.58"
  }), React.createElement("polygon", {
    points: "82.2 54 82.43 53.77 82.51 53.78 82.39 53.95 82.2 54"
  }), React.createElement("polygon", {
    points: "85.05 53.8 85.21 53.77 85.48 53.93 85.25 54.07 85.05 53.8"
  }), React.createElement("polygon", {
    points: "80.73 54.95 81.14 54.73 80.95 55.64 80.72 55.58 80.73 54.95"
  }), React.createElement("polygon", {
    points: "155.91 57.42 155.92 57.4 155.93 57.46 155.92 57.45 155.91 57.42"
  }), React.createElement("polygon", {
    points: "157.98 56.41 157.98 56.39 158.02 56.4 157.99 56.43 157.98 56.41"
  }), React.createElement("polygon", {
    points: "157.91 56.45 157.95 56.44 157.96 56.47 157.94 56.48 157.91 56.45"
  }), React.createElement("polygon", {
    points: "155.34 55.2 155.35 55.18 155.38 55.18 155.37 55.22 155.34 55.2"
  }), React.createElement("polygon", {
    points: "160.05 59.16 160.09 59.16 160.07 59.21 160.06 59.21 160.05 59.16"
  }), React.createElement("polygon", {
    points: "157.48 58.07 157.49 58.03 157.53 58.01 157.51 58.08 157.48 58.07"
  }), React.createElement("polygon", {
    points: "158 56.52 158 56.49 158.09 56.47 158.05 56.53 158 56.52"
  }), React.createElement("polygon", {
    points: "158.22 56.73 158.23 56.7 158.3 56.74 158.28 56.77 158.22 56.73"
  }), React.createElement("polygon", {
    points: "153.06 57.69 153.1 57.71 153.14 57.83 153.12 57.91 153.04 57.99 153.06 57.69"
  }), React.createElement("polygon", {
    points: "152.68 58.03 152.83 58.07 153 58.01 152.83 58.08 152.68 58.03"
  }), React.createElement("polygon", {
    points: "158.07 56.55 158.17 56.49 158.2 56.52 158.09 56.59 158.07 56.55"
  }), React.createElement("polygon", {
    points: "158.49 56.98 158.57 56.93 158.59 56.93 158.55 57.04 158.49 56.98"
  }), React.createElement("polygon", {
    points: "155.94 57.42 155.97 57.34 155.98 57.31 156.02 57.42 155.94 57.42"
  }), React.createElement("polygon", {
    points: "159 57.21 159.05 57.16 159.15 57.25 159.09 57.28 159 57.21"
  }), React.createElement("polygon", {
    points: "160.5 57.79 160.58 57.8 160.59 57.89 160.51 57.88 160.5 57.79"
  }), React.createElement("polygon", {
    points: "159.29 58.78 159.36 58.71 159.41 58.75 159.38 58.81 159.29 58.78"
  }), React.createElement("polygon", {
    points: "155.6 57.28 155.63 57.21 155.7 57.19 155.69 57.33 155.6 57.28"
  }), React.createElement("polygon", {
    points: "160.55 56.85 160.61 56.82 160.69 56.91 160.59 56.96 160.55 56.85"
  }), React.createElement("polygon", {
    points: "158.31 56.82 158.53 56.82 158.53 56.88 158.44 56.92 158.31 56.82"
  }), React.createElement("polygon", {
    points: "160.06 57.5 160.23 57.57 160.26 57.69 160.19 57.7 160.06 57.5"
  }), React.createElement("polygon", {
    points: "161.28 59.1 161.4 58.99 161.48 59.05 161.4 59.18 161.28 59.1"
  }), React.createElement("polygon", {
    points: "158.38 58.22 158.57 58.28 158.52 58.43 158.42 58.35 158.38 58.22"
  }), React.createElement("polygon", {
    points: "158.56 58.42 158.58 58.31 158.88 58.53 158.69 58.54 158.56 58.42"
  }), React.createElement("polygon", {
    points: "160.69 59.03 160.84 59.05 160.82 59.37 160.73 59.21 160.69 59.03"
  }), React.createElement("polygon", {
    points: "160.46 59.25 160.63 59.3 160.64 59.05 160.66 59.4 160.46 59.25"
  }), React.createElement("polygon", {
    points: "155.72 57.2 155.94 57.2 155.89 57.44 155.77 57.41 155.72 57.2"
  }), React.createElement("polygon", {
    points: "159.44 58.83 159.63 58.75 159.62 58.88 159.68 59 159.66 59.05 159.44 58.83"
  }), React.createElement("polygon", {
    points: "154.83 57.25 155.05 57.08 155.25 57.28 154.91 57.32 154.83 57.25"
  }), React.createElement("polygon", {
    points: "159.68 58.91 160.01 58.95 160 59.18 159.69 59.1 159.68 58.91"
  }), React.createElement("polygon", {
    points: "156.03 57.25 156.53 57.33 156.56 57.38 156.13 57.5 156.03 57.25"
  }), React.createElement("polygon", {
    points: "160.5 57.1 160.84 57.02 160.87 57.3 160.56 57.3 160.5 57.1"
  }), React.createElement("polygon", {
    points: "160.09 59.03 160.55 58.92 160.61 58.97 160.34 59.32 160.09 59.03"
  }), React.createElement("polygon", {
    points: "155.22 55.21 155.5 55.1 155.62 55.89 155.36 55.8 155.22 55.21"
  }), React.createElement("polygon", {
    points: "160.56 57.36 160.82 57.45 161.09 57.75 160.77 58.1 160.56 57.36"
  }), React.createElement("polygon", {
    points: "160.92 59.17 161.35 59.34 161.5 59.11 161.95 59.38 161.17 59.41 160.92 59.17"
  }), React.createElement("polygon", {
    points: "127.75 54.9 127.77 54.84 127.86 54.84 127.85 54.9 127.75 54.9"
  }), React.createElement("polygon", {
    points: "119.22 55.42 119.34 55.5 119.33 55.58 119.28 55.56 119.22 55.42"
  }), React.createElement("polygon", {
    points: "119.05 55.48 119.14 55.42 119.16 55.56 119.08 55.55 119.05 55.48"
  }), React.createElement("polygon", {
    points: "123.45 55.06 123.5 55.02 123.68 55.11 123.54 55.18 123.45 55.06"
  }), React.createElement("polygon", {
    points: "130.77 54.6 130.93 54.53 131.22 54.59 131.3 54.52 131.28 54.57 131.16 54.63 130.77 54.6"
  }), React.createElement("polygon", {
    points: "133.02 62.52 133.09 62.41 133.3 62.31 133.24 62.48 133.02 62.52"
  }), React.createElement("polygon", {
    points: "133.42 62.28 134.13 60.92 135.23 60.59 134.74 61.43 133.42 62.28"
  }), React.createElement("polygon", {
    points: "163.06 58.51 163.09 58.53 163.09 58.55 163.08 58.55 163.06 58.51"
  }), React.createElement("polygon", {
    points: "163.21 58.41 163.23 58.4 163.27 58.45 163.23 58.43 163.21 58.41"
  }), React.createElement("polygon", {
    points: "163.69 58.06 163.7 58.03 163.76 58.09 163.74 58.1 163.69 58.06"
  }), React.createElement("polygon", {
    points: "163.01 58.56 163.04 58.54 163.06 58.59 163.02 58.59 163.01 58.56"
  }), React.createElement("polygon", {
    points: "163.62 58.06 163.66 58.11 163.66 58.14 163.62 58.1 163.62 58.06"
  }), React.createElement("polygon", {
    points: "163.59 58.15 163.61 58.1 163.64 58.18 163.62 58.18 163.59 58.15"
  }), React.createElement("polygon", {
    points: "163.13 58.11 163.19 58.15 163.19 58.18 163.16 58.16 163.13 58.11"
  }), React.createElement("polygon", {
    points: "163.8 57.9 163.85 57.92 163.89 58 163.85 57.98 163.8 57.9"
  }), React.createElement("polygon", {
    points: "163.02 58.38 163.12 58.45 163.15 58.52 163.08 58.48 163.02 58.38"
  }), React.createElement("polygon", {
    points: "163.03 58.34 163.12 58.36 163.21 58.48 163.17 58.47 163.03 58.34"
  }), React.createElement("polygon", {
    points: "163.08 58.25 163.19 58.26 163.31 58.43 163.23 58.4 163.08 58.25"
  }), React.createElement("polygon", {
    points: "163.22 58.2 163.29 58.09 163.47 58.29 163.41 58.3 163.22 58.2"
  }), React.createElement("polygon", {
    points: "163.84 57.67 164.08 57.78 164.15 57.97 164.08 57.96 163.84 57.67"
  }), React.createElement("polygon", {
    points: "163.57 57.63 163.78 57.66 164.03 57.95 163.82 57.87 163.57 57.63"
  }), React.createElement("polygon", {
    points: "162.68 58.58 162.89 58.3 163.03 58.68 162.8 58.64 162.68 58.58"
  }), React.createElement("polygon", {
    points: "163.41 57.71 163.68 57.78 163.87 58.09 163.7 58.02 163.41 57.71"
  }), React.createElement("polygon", {
    points: "163.27 58.04 163.48 57.91 163.6 58.26 163.47 58.21 163.27 58.04"
  }), React.createElement("polygon", {
    points: "140.33 58.27 140.35 58.25 140.39 58.25 140.38 58.3 140.33 58.27"
  }), React.createElement("polygon", {
    points: "140.35 58.35 140.47 58.24 140.58 58.34 140.46 58.41 140.35 58.35"
  }), React.createElement("polygon", {
    points: "140.08 57.5 140.47 57.78 140.49 58.19 140.33 58.24 140.27 58.39 140.08 57.5"
  }), React.createElement("polygon", {
    points: "151.13 54.2 151.18 54.22 151.16 54.26 151.13 54.23 151.13 54.2"
  }), React.createElement("polygon", {
    points: "146.81 56.91 146.88 56.85 146.9 56.87 146.88 56.95 146.81 56.91"
  }), React.createElement("polygon", {
    points: "148.81 57.79 148.89 57.77 148.91 57.86 148.84 57.85 148.81 57.79"
  }), React.createElement("polygon", {
    points: "148.68 57.93 148.72 57.84 148.77 57.87 148.77 57.95 148.68 57.93"
  }), React.createElement("polygon", {
    points: "146.48 56.78 146.59 56.7 146.63 56.71 146.59 56.81 146.48 56.78"
  }), React.createElement("polygon", {
    points: "146.65 56.67 146.77 56.62 146.85 56.67 146.75 56.72 146.65 56.67"
  }), React.createElement("polygon", {
    points: "145.35 55.8 145.41 55.81 145.53 55.95 145.44 55.96 145.35 55.8"
  }), React.createElement("polygon", {
    points: "148.44 57.84 148.66 57.82 148.68 57.9 148.49 57.94 148.44 57.84"
  }), React.createElement("polygon", {
    points: "149.75 58.13 150.05 58.06 150.12 57.75 150.06 58.09 149.75 58.13"
  }), React.createElement("polygon", {
    points: "146.69 56.78 146.72 56.74 146.87 56.68 146.86 56.85 146.69 56.78"
  }), React.createElement("polygon", {
    points: "147.1 58.58 147.27 58.48 147.29 58.67 147.2 58.7 147.1 58.58"
  }), React.createElement("polygon", {
    points: "146.77 58.7 146.89 58.57 146.98 58.6 146.91 58.79 146.77 58.7"
  }), React.createElement("polygon", {
    points: "145.55 55.97 145.93 56.08 146.23 56.3 146.26 56.53 145.55 55.97"
  }), React.createElement("polygon", {
    points: "148.82 55 148.94 54.73 149.16 54.76 149.07 55.13 148.82 55"
  }), React.createElement("polygon", {
    points: "77.86 56.1 77.88 56.07 77.94 56.08 77.91 56.11 77.86 56.1"
  }), React.createElement("polygon", {
    points: "69.27 55.61 69.28 55.57 69.37 55.53 69.32 55.6 69.27 55.61"
  }), React.createElement("polygon", {
    points: "76.9 55.78 77.22 55.74 77.33 55.87 77.17 55.94 76.9 55.78"
  }), React.createElement("polygon", {
    points: "112.36 54.15 112.45 54.17 112.44 54.22 112.4 54.21 112.36 54.15"
  }), React.createElement("polygon", {
    points: "113.66 52.7 113.74 52.59 113.83 52.59 113.8 52.73 113.66 52.7"
  }), React.createElement("polygon", {
    points: "116.34 52.6 116.49 52.64 116.64 52.76 116.56 52.77 116.34 52.6"
  }), React.createElement("polygon", {
    points: "114.3 53.92 114.43 53.9 114.47 54.04 114.31 54.08 114.3 53.92"
  }), React.createElement("polygon", {
    points: "115.77 52.88 115.84 52.8 116 53 115.79 53 115.77 52.88"
  }), React.createElement("polygon", {
    points: "114.32 53.69 114.41 53.62 114.55 53.7 114.39 53.88 114.32 53.69"
  }), React.createElement("polygon", {
    points: "112.76 53.28 113.2 53.38 113.31 53.53 112.82 53.43 112.76 53.28"
  }), React.createElement("polygon", {
    points: "113.75 52.57 114.03 52.37 114.14 52.47 113.97 52.67 113.83 52.7 113.84 52.59 113.75 52.57"
  }), React.createElement("polygon", {
    points: "202.17 44.13 202.18 44.09 202.19 44.09 202.2 44.14 202.17 44.13"
  }), React.createElement("polygon", {
    points: "202.21 44.09 202.24 44.05 202.28 44.09 202.23 44.13 202.21 44.09"
  }), React.createElement("polygon", {
    points: "71.69 39.37 71.73 39.33 71.78 39.39 71.72 39.4 71.69 39.37"
  }), React.createElement("polygon", {
    points: "70.5 42.78 70.57 42.77 70.59 42.85 70.52 42.83 70.5 42.78"
  }), React.createElement("polygon", {
    points: "70.47 42.91 70.64 42.92 70.64 43.03 70.57 43.05 70.47 42.91"
  }), React.createElement("polygon", {
    points: "204.45 39.48 204.46 39.45 204.52 39.45 204.49 39.52 204.45 39.48"
  }), React.createElement("polygon", {
    points: "220.5 25.66 221.87 25.52 222.15 26.53 220.66 26.46 220.5 25.66"
  }), React.createElement("polygon", {
    points: "222.35 26.42 222.66 26.19 222.78 26.27 222.6 26.58 222.35 26.42"
  }), React.createElement("polygon", {
    points: "247.75 36.25 247.82 36.21 247.85 36.32 247.79 36.31 247.75 36.25"
  }), React.createElement("polygon", {
    points: "230.89 34.85 231.07 34.88 231.22 34.97 231.07 34.89 230.89 34.85"
  }), React.createElement("polygon", {
    points: "230 34.83 230.17 34.83 230.29 34.89 230.37 34.97 230 34.83"
  }), React.createElement("polygon", {
    points: "216.99 28.57 217.01 28.54 217.03 28.57 216.99 28.6 216.99 28.57"
  }), React.createElement("polygon", {
    points: "244.76 16.61 248.87 18.41 252.73 17.14 253.68 17.86 253.32 19.77 255.33 19.54 255.41 18.94 256 20.11 253.23 20.77 252.2 22.34 251.02 21.76 249.92 23.54 248.09 21.1 245.92 21.77 245.04 21.13 245.84 18.73 244.76 16.61"
  }), React.createElement("polygon", {
    points: "253.32 21.5 253.32 21.64 253.15 21.51 253.23 21.47 253.32 21.5"
  }), React.createElement("polygon", {
    points: "242.76 15.55 242.8 15.55 242.81 15.57 242.77 15.58 242.76 15.55"
  }), React.createElement("polygon", {
    points: "253.06 21.33 253.09 21.34 253.08 21.38 253.07 21.37 253.06 21.33"
  }), React.createElement("polygon", {
    points: "242.82 15.51 242.87 15.52 242.85 15.55 242.83 15.54 242.82 15.51"
  }), React.createElement("polygon", {
    points: "244.14 15.51 244.19 15.52 244.19 15.56 244.16 15.56 244.14 15.51"
  }), React.createElement("polygon", {
    points: "244.03 20.21 244.05 20.17 244.13 20.18 244.07 20.21 244.03 20.21"
  }), React.createElement("polygon", {
    points: "243.61 19.91 243.66 19.88 243.69 19.93 243.64 19.93 243.61 19.91"
  }), React.createElement("polygon", {
    points: "244.62 16.25 244.63 16.2 244.66 16.2 244.65 16.3 244.62 16.25"
  }), React.createElement("polygon", {
    points: "244.49 16.27 244.58 16.23 244.59 16.29 244.53 16.3 244.49 16.27"
  }), React.createElement("polygon", {
    points: "244.28 16.4 244.37 16.44 244.4 16.5 244.34 16.51 244.28 16.4"
  }), React.createElement("polygon", {
    points: "244.14 20.19 244.16 20.12 244.24 20.12 244.23 20.22 244.14 20.19"
  }), React.createElement("polygon", {
    points: "243.55 19.45 243.57 19.34 243.63 19.36 243.63 19.46 243.55 19.45"
  }), React.createElement("polygon", {
    points: "242.04 15.21 242.08 15.16 242.23 15.31 242.06 15.33 242.04 15.21"
  }), React.createElement("polygon", {
    points: "254.52 16.62 254.53 16.6 254.56 16.62 254.54 16.64 254.52 16.62"
  }), React.createElement("polygon", {
    points: "254.4 16.9 254.41 16.86 254.43 16.83 254.46 16.89 254.4 16.9"
  }), React.createElement("polygon", {
    points: "253.69 17.59 253.74 17.52 253.78 17.58 253.73 17.65 253.69 17.59"
  }), React.createElement("polygon", {
    points: "254.08 18.8 254.18 18.78 254.23 18.86 254.16 18.87 254.08 18.8"
  }), React.createElement("polygon", {
    points: "249.49 17.73 249.53 17.66 249.54 17.6 249.59 17.73 249.49 17.73"
  }), React.createElement("polygon", {
    points: "254.85 17.36 254.9 17.31 255.21 17.61 254.85 17.45 254.85 17.36"
  }), React.createElement("polygon", {
    points: "239.88 17.73 239.92 17.72 239.93 17.77 239.88 17.75 239.88 17.73"
  }), React.createElement("polygon", {
    points: "239.95 18.09 239.97 18.09 240 18.14 239.97 18.13 239.95 18.09"
  }), React.createElement("polygon", {
    points: "239.88 17.94 239.98 17.82 240.08 17.93 239.95 18.06 239.88 17.94"
  }), React.createElement("polygon", {
    points: "108.26 2.19 108.27 2.17 108.31 2.18 108.3 2.19 108.26 2.19"
  }), React.createElement("polygon", {
    points: "108.43 2.14 108.45 2.11 108.49 2.17 108.45 2.17 108.43 2.14"
  }), React.createElement("polygon", {
    points: "146.74 2.37 146.75 2.37 146.76 2.38 146.75 2.38 146.74 2.37"
  }), React.createElement("polygon", {
    points: "145.93 2.25 145.93 2.24 145.94 2.25 145.93 2.25 145.93 2.25"
  }), React.createElement("rect", {
    x: "144.39",
    y: "2.18",
    width: "0.01",
    height: "0.01"
  }), React.createElement("rect", {
    x: "66.46",
    y: "21.09",
    width: "0.01",
    height: "0.01",
    transform: "translate(75.62 13.22) rotate(-26.78)"
  }), React.createElement("polygon", {
    points: "145.07 2.14 145.08 2.13 145.09 2.13 145.09 2.14 145.07 2.14"
  }), React.createElement("polygon", {
    points: "144.89 2.12 144.91 2.11 144.92 2.12 144.9 2.13 144.89 2.12"
  }), React.createElement("polygon", {
    points: "145.21 2.2 145.23 2.19 145.24 2.19 145.23 2.21 145.21 2.2"
  }), React.createElement("polygon", {
    points: "145 2.18 145.03 2.17 145.05 2.17 145.03 2.19 145 2.18"
  }), React.createElement("polygon", {
    points: "144.58 2.19 144.59 2.17 144.63 2.17 144.61 2.19 144.58 2.19"
  }), React.createElement("polygon", {
    points: "144.21 2.18 144.25 2.17 144.26 2.17 144.25 2.19 144.21 2.18"
  }), React.createElement("polygon", {
    points: "145.32 2.21 145.34 2.19 145.38 2.19 145.35 2.21 145.32 2.21"
  }), React.createElement("polygon", {
    points: "146.17 2.19 146.25 2.19 146.28 2.2 146.22 2.22 146.17 2.19"
  }), React.createElement("polygon", {
    points: "147.57 2.44 147.68 2.44 147.72 2.48 147.6 2.49 147.57 2.44"
  }), React.createElement("polygon", {
    points: "135.54 3.77 135.55 3.77 135.55 3.79 135.54 3.78 135.54 3.77"
  }), React.createElement("polygon", {
    points: "134.02 3.2 134.02 3.19 134.03 3.19 134.03 3.2 134.02 3.2"
  }), React.createElement("rect", {
    x: "134.07",
    y: "3.17",
    width: "0.01",
    height: "0.01"
  }), React.createElement("polygon", {
    points: "133.61 3.02 133.61 3.02 133.63 3.02 133.62 3.02 133.61 3.02"
  }), React.createElement("polygon", {
    points: "135.93 3.9 135.93 3.89 135.94 3.89 135.94 3.91 135.93 3.9"
  }), React.createElement("polygon", {
    points: "134.66 3.38 134.67 3.37 134.68 3.38 134.67 3.38 134.66 3.38"
  }), React.createElement("polygon", {
    points: "135.79 3.87 135.8 3.86 135.81 3.85 135.8 3.88 135.79 3.87"
  }), React.createElement("polygon", {
    points: "134.34 3.27 134.34 3.26 134.36 3.27 134.35 3.27 134.34 3.27"
  }), React.createElement("polygon", {
    points: "134.93 3.51 134.94 3.5 134.95 3.5 134.94 3.52 134.93 3.51"
  }), React.createElement("polygon", {
    points: "134.98 3.5 134.99 3.5 135 3.51 134.98 3.52 134.98 3.5"
  }), React.createElement("polygon", {
    points: "134.75 3.41 134.75 3.39 134.77 3.42 134.75 3.42 134.75 3.41"
  }), React.createElement("polygon", {
    points: "135.26 3.7 135.26 3.69 135.28 3.69 135.28 3.72 135.26 3.7"
  }), React.createElement("polygon", {
    points: "134.29 3.29 134.32 3.28 134.34 3.29 134.31 3.3 134.29 3.29"
  }), React.createElement("polygon", {
    points: "134.77 3.42 134.83 3.44 134.83 3.45 134.81 3.45 134.77 3.42"
  }), React.createElement("polygon", {
    points: "134.86 3.47 134.9 3.46 134.93 3.5 134.9 3.51 134.86 3.47"
  }), React.createElement("polygon", {
    points: "138.16 4.25 138.2 4.24 138.24 4.27 138.2 4.28 138.16 4.25"
  }), React.createElement("polygon", {
    points: "135.18 3.79 135.2 3.74 135.23 3.73 135.23 3.78 135.18 3.79"
  }), React.createElement("polygon", {
    points: "134.1 3.21 134.15 3.21 134.19 3.25 134.13 3.25 134.1 3.21"
  }), React.createElement("polygon", {
    points: "133.49 2.98 133.56 2.96 133.6 3 133.56 3.02 133.49 2.98"
  }), React.createElement("rect", {
    x: "131.41",
    y: "2.66"
  }), React.createElement("rect", {
    x: "52.86",
    y: "21.53",
    height: "0.01",
    transform: "translate(78.26 24.69) rotate(-45)"
  }), React.createElement("rect", {
    x: "53.68",
    y: "21.8",
    width: "0.01",
    height: "0.01",
    transform: "translate(88.11 41.01) rotate(-63.35)"
  }), React.createElement("polygon", {
    points: "131.77 2.79 131.77 2.78 131.78 2.79 131.77 2.79"
  }), React.createElement("rect", {
    x: "53.48",
    y: "21.65",
    height: "0.01",
    transform: "matrix(0.6, -0.8, 0.8, 0.6, 81.99, 32.32)"
  }), React.createElement("polygon", {
    points: "131.68 2.77 131.69 2.76 131.7 2.77 131.69 2.77 131.68 2.77"
  }), React.createElement("polygon", {
    points: "131.59 2.74 131.59 2.73 131.6 2.74 131.6 2.75 131.59 2.74"
  }), React.createElement("polygon", {
    points: "132.1 2.92 132.11 2.92 132.13 2.92 132.12 2.93 132.1 2.92"
  }), React.createElement("polygon", {
    points: "128.85 3 128.85 2.99 128.86 2.99 128.86 3 128.85 3"
  }), React.createElement("polygon", {
    points: "131.81 2.78 131.81 2.75 131.82 2.76 131.82 2.79 131.81 2.78"
  }), React.createElement("polygon", {
    points: "131.88 2.8 131.89 2.79 131.91 2.81 131.9 2.82 131.88 2.8"
  }), React.createElement("polygon", {
    points: "131.64 2.74 131.64 2.73 131.67 2.72 131.66 2.75 131.64 2.74"
  }), React.createElement("polygon", {
    points: "131.84 2.8 131.87 2.78 131.88 2.8 131.85 2.81 131.84 2.8"
  }), React.createElement("polygon", {
    points: "129.19 2.39 129.23 2.4 129.23 2.44 129.2 2.43 129.19 2.39"
  }), React.createElement("polygon", {
    points: "130.8 2.56 130.83 2.54 130.87 2.57 130.83 2.58 130.8 2.56"
  }), React.createElement("polygon", {
    points: "124.78 2.14 124.78 2.14 124.78 2.13 124.78 2.14 124.78 2.14"
  }), React.createElement("rect", {
    x: "126.46",
    y: "2.22",
    width: "0.01",
    height: "0.01"
  }), React.createElement("polygon", {
    points: "126.23 2.19 126.23 2.18 126.25 2.18 126.24 2.19 126.23 2.19"
  }), React.createElement("polygon", {
    points: "126.51 2.25 126.53 2.25 126.54 2.27 126.53 2.27 126.51 2.25"
  }), React.createElement("polygon", {
    points: "126.34 2.2 126.37 2.19 126.38 2.19 126.37 2.21 126.34 2.2"
  }), React.createElement("polygon", {
    points: "219.38 11.25 219.4 11.23 219.42 11.24 219.41 11.26 219.38 11.25"
  }), React.createElement("polygon", {
    points: "222.33 12.93 222.35 12.89 222.37 12.89 222.37 12.91 222.33 12.93"
  }), React.createElement("polygon", {
    points: "222.6 13 222.61 12.97 222.65 12.95 222.61 13 222.6 13"
  }), React.createElement("polygon", {
    points: "220.61 11.8 220.65 11.75 220.66 11.74 220.65 11.78 220.61 11.8"
  }), React.createElement("polygon", {
    points: "222.14 12.83 222.14 12.82 222.19 12.79 222.18 12.84 222.14 12.83"
  }), React.createElement("polygon", {
    points: "222.28 12.88 222.29 12.85 222.31 12.84 222.31 12.88 222.28 12.88"
  }), React.createElement("polygon", {
    points: "223.66 13.68 223.75 13.63 223.78 13.62 223.69 13.68 223.66 13.68"
  }), React.createElement("polygon", {
    points: "223.84 13.61 223.9 13.58 223.94 13.59 223.85 13.62 223.84 13.61"
  }), React.createElement("polygon", {
    points: "219.4 11.39 219.41 11.37 219.47 11.38 219.46 11.4 219.4 11.39"
  }), React.createElement("polygon", {
    points: "224.08 13.9 224.11 13.86 224.16 13.84 224.1 13.9 224.08 13.9"
  }), React.createElement("polygon", {
    points: "224.99 14.06 225.03 14.01 225.06 14.01 225.05 14.05 224.99 14.06"
  }), React.createElement("polygon", {
    points: "220.63 11.65 220.67 11.6 220.7 11.61 220.69 11.66 220.63 11.65"
  }), React.createElement("polygon", {
    points: "223.35 13.27 223.39 13.21 223.44 13.22 223.44 13.29 223.35 13.27"
  }), React.createElement("polygon", {
    points: "223.09 13.25 223.24 13.12 223.31 13.15 223.31 13.2 223.09 13.25"
  }), React.createElement("polygon", {
    points: "222.22 13.2 222.41 13.1 222.53 13.16 222.41 13.3 222.22 13.2"
  }), React.createElement("polygon", {
    points: "226.85 15.2 226.91 15.05 227.3 15 227.15 15.16 226.85 15.2"
  }), React.createElement("polygon", {
    points: "223.16 13.75 223.3 13.47 223.65 13.55 223.3 13.77 223.16 13.75"
  }), React.createElement("polygon", {
    points: "221.1 12.31 221.96 12.6 222.05 13.02 221.38 13.04 221.1 12.31"
  }), React.createElement("polygon", {
    points: "181.46 6.61 181.49 6.62 181.5 6.67 181.48 6.67 181.46 6.61"
  }), React.createElement("polygon", {
    points: "178.84 5.08 178.84 5.04 178.9 5 178.9 5.03 178.84 5.08"
  }), React.createElement("polygon", {
    points: "174.46 4.54 174.49 4.52 174.57 4.57 174.48 4.59 174.46 4.54"
  }), React.createElement("polygon", {
    points: "184.06 6.01 184.28 6.03 184.31 6.16 184.13 6.22 184.06 6.01"
  }), React.createElement("polygon", {
    points: "165.28 3.93 165.36 3.83 165.49 3.87 165.38 3.96 165.28 3.93"
  }), React.createElement("rect", {
    x: "24.59",
    y: "21.3",
    width: "0.01",
    height: "0.01",
    transform: "translate(74.61 18.9) rotate(-71.57)"
  }), React.createElement("polygon", {
    points: "103.1 2.3 103.11 2.29 103.12 2.3 103.11 2.31 103.1 2.3"
  }), React.createElement("polygon", {
    points: "102.79 2.3 102.8 2.29 102.83 2.3 102.79 2.31 102.79 2.3"
  }), React.createElement("polygon", {
    points: "101.54 2.27 101.64 2.25 101.67 2.31 101.6 2.3 101.54 2.27"
  }), React.createElement("polygon", {
    points: "102.91 2.29 103.01 2.27 103.06 2.3 102.99 2.34 102.91 2.29"
  }), React.createElement("rect", {
    x: "39.86",
    y: "22.2",
    width: "0.01",
    height: "0.01",
    transform: "translate(72.27 1.31) rotate(-26.74)"
  }), React.createElement("polygon", {
    points: "118 3.23 118 3.21 118.02 3.22 118 3.23 118 3.23"
  }), React.createElement("polygon", {
    points: "117.26 3.35 117.26 3.35 117.28 3.34 117.27 3.36 117.26 3.35"
  }), React.createElement("polygon", {
    points: "117.18 3.38 117.19 3.36 117.19 3.36 117.19 3.38 117.18 3.38"
  }), React.createElement("polygon", {
    points: "117.15 3.39 117.16 3.39 117.18 3.4 117.16 3.41 117.15 3.39"
  }), React.createElement("polygon", {
    points: "117.11 3.5 117.13 3.5 117.14 3.51 117.11 3.52 117.11 3.5"
  }), React.createElement("polygon", {
    points: "117.79 3.29 117.8 3.27 117.83 3.26 117.82 3.28 117.79 3.29"
  }), React.createElement("polygon", {
    points: "43.42 12.64 44.4 12.24 45.13 13.12 44.6 13.5 43.42 12.64"
  }), React.createElement("polygon", {
    points: "97.1 14.12 97.13 14.08 97.14 14.07 97.13 14.12 97.1 14.12"
  }), React.createElement("polygon", {
    points: "179.69 8.45 179.75 8.39 179.86 8.42 179.74 8.52 179.69 8.45"
  }), React.createElement("polygon", {
    points: "177 8 177.08 7.97 177.19 8.07 177.16 8.07 177 8"
  }), React.createElement("polygon", {
    points: "175.86 7.6 175.93 7.5 176.1 7.65 176.07 7.67 175.86 7.6"
  }));
});

var RI = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.49 256"
  }, React.createElement("polygon", {
    points: "61.2 254.8 54.64 256 51.49 254.03 50.69 249.72 53.13 243.47 58.65 240.8 58.56 233.34 62.16 234.62 62.35 243.87 66.06 251.77 61.2 254.8"
  }), React.createElement("polygon", {
    points: "101.13 163.9 99.27 162.37 99.75 152.15 102.93 147.91 100.52 145.15 104.42 129.86 108.55 133.29 108.98 142.15 105.85 158.22 101.13 163.9"
  }), React.createElement("polygon", {
    points: "135.59 152.84 136.57 156.13 129.62 154.11 121.08 162.93 116.66 162.24 111.5 166.41 109.63 165.34 110.34 159.57 119.82 154.32 116.07 147.06 119.71 139.29 119.78 132.87 126.28 125.33 128.85 113.61 139.32 105.3 136.72 121.52 135.59 152.84"
  }), React.createElement("polygon", {
    points: "161.49 148.98 147.26 162.16 143.63 152.12 145.02 146.72 141.64 122.57 142.38 109.52 145.21 100.46 159.21 105.07 156.84 121.32 159.29 124.56 161.49 148.98"
  }), React.createElement("polygon", {
    points: "104.64 35.52 113.15 37.19 112.51 64.93 116.27 70.59 128.72 78.87 135.65 90.81 134.78 99.16 128.89 103.7 121.25 105.61 120.14 98.18 125.37 79.14 121.86 76.98 119.68 87.12 113.38 83.63 109.24 79.93 105.95 66.37 101.29 58.42 101.32 81.06 106.63 86.6 107.4 90.09 102.86 101.33 99.76 96.72 95.27 95.25 89.01 100.43 94.23 103.13 97.14 113.57 96.67 119.56 89.91 130.88 93.97 141.48 94.26 157.05 93.67 162.28 79.78 191.4 77.67 192.67 67.76 188.81 57.48 189.26 20.41 203.04 0 205.84 3.46 185.03 6.23 178.68 9.16 177.93 11.21 147.32 10.59 1.35 102.13 0 104.64 35.52"
  }));
});

var SC = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 205.92"
  }, React.createElement("polygon", {
    points: "214.5 142.47 214.34 140.07 215.69 138.55 215.51 139.91 214.5 142.47"
  }), React.createElement("polygon", {
    points: "53.05 1.12 122.22 4.76 123.05 10.41 128.97 7.31 136.44 17.04 137.35 25.81 197.09 27.29 255.95 85.11 254.52 85.57 256 87.34 245.88 92.04 236.65 101.03 226.39 115.72 223.9 128.63 222.16 123.32 218.99 122.31 223.31 114.51 221.03 116.16 217.52 123.66 223.93 130.83 221.42 133.56 219.32 132.05 219.19 134.88 215.45 132.77 218.09 135.77 213.86 138.72 213.07 141.75 207.43 143.5 205.82 140.32 202.32 142.13 200.23 146.67 201.19 148.43 202.99 147.09 202.2 148.56 189.26 158.48 185.02 156.1 185.74 152.58 182.94 152.83 183.51 157.21 181.68 157.11 187.14 160.09 186.98 162.02 182.96 165.61 178.6 165.94 179.75 168.33 170.38 171.28 165.51 167.81 168.9 171.71 162 176.54 159.92 173.53 158.66 177.1 150.59 171.82 150.98 174.5 143.5 174.39 143.08 175.89 153.97 177.13 148.01 178.52 155.08 180.66 150.25 185.59 156.65 181.52 154.43 187.14 145.35 190.78 144.19 178.16 142.75 178.05 143.07 188.47 138.63 184.75 137.18 175.98 133.38 173.23 136.47 187.4 143.11 194.15 135.29 201.04 137.67 194.65 137.52 192.23 131.48 205.92 125.55 202.41 121.17 202.41 116.88 195.52 118.23 187.31 114.48 176.77 103.31 167.73 103.52 159.96 98.24 147.89 97.34 140.93 84.25 133.34 83.34 129.34 79.49 126.63 79.89 123.14 75.08 120.03 74.77 112.63 68.14 106.2 62.12 103.44 56.93 92.97 41.07 80.51 39.16 74.77 32.78 67.28 26.24 48.48 16.14 45.97 9.84 38.32 0 31.96 2.68 24.82 13.2 13.4 32.58 9.07 36.65 5.64 49.43 2.54 51.79 0 53.05 1.12"
  }));
});

var SD = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 157.81"
  }, React.createElement("polygon", {
    points: "246.82 0.9 244.43 9.4 237.6 16.95 242.93 24.96 247.56 26.06 251.4 30.35 255.01 112.73 250.18 113.11 252.6 118.58 251.63 125.36 254.67 125.78 255.71 130.09 250.28 147.36 254.32 151.69 256 157.81 251 156.91 248.44 151.06 233.68 146.23 228.51 142.05 209.52 143.21 203.94 147.37 187.59 137.8 92.63 137.92 0 134.85 7.02 0 127.45 3.23 246.82 0.9"
  }));
});

var TN = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 62.32"
  }, React.createElement("polygon", {
    points: "197.19 2.94 256 0.73 254.74 10.46 249.61 11.66 244.75 19.42 240.41 17.76 230.46 25.3 228.27 21.91 223.1 26.59 220.21 26.22 217.93 32.19 212.64 33.35 203.08 40.38 191.57 42.74 187.99 46.01 186.11 51.72 179.81 53.23 178.95 62.07 107.14 62.32 0 58.74 7 54.1 6.44 46.03 12.57 39.79 11.82 33.4 18.77 29.66 17.77 26.88 20.28 27.43 19.23 22.36 22.38 18.59 20.15 14.68 24.1 14.21 22.23 11.32 25.15 9.89 24.45 5.63 26.76 7.45 28.42 5.81 68.94 6.96 68.37 0 75.01 1.83 197.19 2.94"
  }));
});

var TX = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 240.97"
  }, React.createElement("polygon", {
    points: "189.5 234.66 184.13 218.38 183.7 211.66 183.91 210.1 184.19 209.75 189.5 234.66"
  }), React.createElement("polygon", {
    points: "187.74 199.23 186.01 202.98 183.95 209.39 186.26 199.32 190.17 194.92 187.74 199.23"
  }), React.createElement("polygon", {
    points: "190.63 194.28 192.71 188.98 193.87 188.2 194.03 189.56 190.63 194.28"
  }), React.createElement("polygon", {
    points: "202.68 182.88 196.89 186.81 194.32 189.54 194.76 186.86 202.68 182.88"
  }), React.createElement("polygon", {
    points: "203.75 181.35 204.44 180.18 206.02 179.39 206.03 179.54 203.75 181.35"
  }), React.createElement("polygon", {
    points: "233.23 158.02 234.5 158.39 227.6 164.18 233.01 158.84 233.23 158.02"
  }), React.createElement("polygon", {
    points: "77.34 0.07 127.3 0.01 128.02 43.66 134.42 47.76 139.05 47.89 140.02 46.01 143.66 51.41 154.81 52.55 156.66 54.36 163.85 52.43 167.47 58.58 172.77 55.63 176.78 59.27 180.95 57.21 182.42 61.34 186.18 55.9 189.78 58.2 192.5 56.79 197.88 61.13 205.04 56.34 208.01 57.08 211.38 54.68 216.05 56.3 218.49 54 234.85 62.01 241.31 61.71 244.05 96.92 248.34 101.33 248.88 105.77 256 117.78 252.64 128.91 253.77 139.91 249.65 145.44 251.64 148.92 246.88 149.79 234.24 157.64 235.32 155.37 239.13 153.66 239.43 152.72 233.23 153.84 233.72 147.97 230.91 151.09 227.82 150.05 230.57 156.62 233.07 157.55 226.35 161.76 226.82 165.46 222.87 169.33 211.41 174.54 211.73 175.96 216.05 173.66 206.3 179.38 210.75 175.58 206.02 177.16 207.77 176.16 206.67 174.75 203.57 176.19 202.7 174.07 201.43 173.36 203.1 176.41 201.97 177.18 200.67 177.63 201.53 176.28 197.33 174.35 200.75 179.18 199.7 180.18 202.64 180.82 197.73 183.7 194.74 180.18 195.22 185.6 193.34 187.77 192.06 188.38 192.61 185.22 191.48 188.24 190.57 186.56 187.41 187.85 188.05 191.33 190.54 189.05 187.51 195.22 180.64 194.67 186.11 198.52 183.37 206.87 180.75 208 181.77 205.44 178.93 207.84 175.84 204.11 178.16 207.63 175.99 208.01 183.14 208.51 180.59 214.8 182.37 217.39 180.75 218.36 186.6 234.52 188.68 235.16 187.86 237.32 189.93 235.48 190.34 237.77 186.4 238.88 185.71 240.97 179.44 236.93 167.75 236.32 155.57 229.88 149.25 228.88 146.11 219.69 141.62 214.52 140.28 202.39 133.73 198.21 129.07 190.03 124.61 186.91 116.48 167.85 105.14 156.37 103.59 156.94 101.73 152.83 87.75 152.25 83.56 150.13 81.85 152.77 76.18 153.64 72.69 165.16 67.32 170.38 62.05 169.55 41.25 156.27 32.3 132.72 23.83 126.74 0.87 103.23 0 99.71 69.57 102.04 71.61 0 77.34 0.07"
  }));
});

var UT = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.26 256"
  }, React.createElement("polygon", {
    points: "64.07 51.78 63.24 50.56 64.23 50.26 64.58 51.36 64.07 51.78"
  }), React.createElement("polygon", {
    points: "77.91 58.6 75.03 53.99 75.1 48.45 78.22 53.46 77.91 58.6"
  }), React.createElement("polygon", {
    points: "72.66 44.96 72.44 45.1 69.77 43.06 71.48 42.66 72.66 44.96"
  }), React.createElement("path", {
    d: "M-31.45-77.61l99.43,1,.28,50.91L145.52-27l5.74,203.67L49.13,178-53,176.4-45.65-78l14.2.39M-.95-58.44-7.38-57-5.61-55-7.39-52.8l3,9.73L-7.3-40.53l1.8.59,1.79-2.84,3,2.94L2-35.73l.66,9.48,4.62,3.32,2.89,5.7,2.79-5.89L16-10.71l2.34.7,6.1-4.26,2.49-5.18,7.34-4.31-6.65-5.1L21.83-39.27l-2.62-.34L22-43.5l5.95.62,1.63-2.88-8.17.35-.58-3.2-4.07-.53,1.61,11.49-3.22,1.27L12-47.21,7.33-48.1,4.07-51.55,5-58.48,2.26-60.73Z",
    transform: "translate(53 78)"
  }));
});

var VA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 110.11"
  }, React.createElement("polygon", {
    points: "237.16 107.75 237.35 108.75 236.31 108.77 236.12 108.32 237.16 107.75"
  }), React.createElement("polygon", {
    points: "239.75 82.85 238.74 82.73 240.34 80.06 240.23 82.27 239.75 82.85"
  }), React.createElement("polygon", {
    points: "242.51 76.65 242.34 76.19 243.66 73.74 243.52 74.62 242.51 76.65"
  }), React.createElement("polygon", {
    points: "250.5 56.63 245 71.26 243.83 72.68 242.54 70.31 241.33 71.72 242.81 72.47 239.45 74.33 238.18 84.84 237.18 82.98 235.49 86.41 233.46 79.74 235.84 68.51 238.88 66.07 239.68 60.85 243.43 59.45 240.88 56.91 244.47 53.54 251.79 52.33 250.5 56.63"
  }), React.createElement("polygon", {
    points: "253.43 57.27 252.61 58.05 251.64 58.15 256 51.62 253.43 57.27"
  }), React.createElement("polygon", {
    points: "177.4 11.13 180.58 4.23 185.79 5.4 188.84 8.06 187.71 12.03 194.35 14.84 201.08 20.95 201.35 26.63 198.14 27.8 197.85 30.32 195.81 29.65 193.69 38.95 192.25 38.19 194.32 40.87 192.68 41.29 201.77 39.2 202.9 41.25 201.43 42.05 204.73 46.45 210.78 49.13 215.11 48.58 217.13 53.24 226.07 57.7 225.73 60.72 223.46 59.79 224.25 67.77 219.24 65.2 218.2 67.19 204.95 50.88 201.08 48.19 198.94 48.22 204.54 51.41 217.13 68 224.93 70.35 221.67 71.81 226.23 72.93 225.79 79.94 221.09 75.25 220.59 79.8 222.53 81.09 220 81.91 209.96 71.96 209.47 73.15 217.75 82.19 222.17 83.2 225.11 87.02 223.71 88.14 225.78 88.24 225.08 91.44 221.07 92.95 214.65 83.82 211.33 84.76 207.71 80.06 205.6 83.05 203.37 80.14 201.82 81.53 195.87 79.23 195.17 80.52 201.48 82.32 202.97 81.2 204.34 83.28 211.57 86.23 213.41 84.9 214.37 90.34 219.66 93.63 218.26 97.31 222.61 95.79 225.37 97.66 225.06 93.57 234.35 94.87 239.07 108.71 235.68 102.33 235.58 108.78 233.16 107.33 233.6 108.82 171.69 110.11 109.35 109.81 0 103.34 16.75 98.57 18.95 94.94 24.93 93.36 31.05 84.67 41.29 79.75 53.36 70.36 54.27 76.77 64.45 83.42 71.29 78.72 75.41 82.27 85.85 79.47 87.05 75.74 90.1 77.45 96.71 74.32 98.96 75.84 103.94 72.75 105.98 68.69 104.22 66.25 119.31 44.17 123.82 32.3 126.84 33.25 127.99 36.46 134.61 38.53 143.23 22.83 147.1 24.9 160.38 10.93 162.85 0 177.4 11.13"
  }));
});

var VT = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.65 256"
  }, React.createElement("polygon", {
    points: "150.92 49.02 148.16 49.78 147.85 55.9 141.54 63.69 127.09 74.83 117.16 75.84 112.47 82.31 111.56 102.12 106.53 113.73 107.94 116.82 101.51 126.75 98.89 137.96 91.39 145.19 89.27 157.12 84.49 163.37 83.56 192.16 80.72 197.46 78.07 225.09 73.89 228.47 71.13 239.38 71.57 244.41 78.42 256 13.62 253.27 11.46 246.44 14.93 163.73 9.98 155.38 6.48 155.48 1.97 161.56 0.52 157.45 5.73 138.2 0 106.81 4.82 91.03 9.39 86.52 8.88 72.88 12.15 62.79 5.61 44.34 9.07 25.29 5.86 17.69 9.21 8.36 8.13 1.16 154.65 0 152.29 4.54 154.03 13.33 146.86 23.89 144.64 30.75 151.61 46.77 150.92 49.02"
  }));
});

var WA = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 166.26"
  }, React.createElement("polygon", {
    points: "21.71 122.86 20.25 121.33 20.82 119.04 21.84 121.22 21.71 122.86"
  }), React.createElement("polygon", {
    points: "63.41 91.52 61.97 90.06 63.34 88.74 64.43 89.58 63.41 91.52"
  }), React.createElement("polygon", {
    points: "58.31 88.82 56.36 85.92 58.88 83.08 58.15 84.48 58.31 88.82"
  }), React.createElement("polygon", {
    points: "72.78 78.11 74.56 79.36 71.19 81.54 72.2 78.86 71.46 78.61 69.85 81.72 69.98 75.81 71.8 73.69 72.78 78.11"
  }), React.createElement("polygon", {
    points: "70.63 68.86 70.47 70.3 67.95 68.79 69.04 63.3 70.63 68.86"
  }), React.createElement("polygon", {
    points: "65.26 47.36 64.47 49.3 63.98 44.77 64.54 45 65.26 47.36"
  }), React.createElement("polygon", {
    points: "68.53 31.08 70.63 35.76 68.2 35.03 63.98 38.48 68.5 40.75 69.75 49.51 70.52 45.47 74.71 49.14 74.42 54.43 71.63 50.46 68.88 50.38 67.61 42.4 65.65 42.5 62.95 38.66 66.3 31.3 68.53 31.08"
  }), React.createElement("polygon", {
    points: "60.26 27.49 60.89 29.63 57.32 26.74 59.51 22.49 60.26 27.49"
  }), React.createElement("polygon", {
    points: "65.28 23.71 63.96 22.07 64.68 20.71 65.93 22.52 65.28 23.71"
  }), React.createElement("polygon", {
    points: "55.79 24.89 56.57 27.88 51.39 25.9 50.03 20.64 52.44 20.22 55.79 24.89"
  }), React.createElement("polygon", {
    points: "60.3 15.68 63.62 18.35 61.34 20.47 59.07 16.07 60.03 20.79 57.76 21.16 56.34 18.92 55.75 20.89 55.05 18.7 58.04 15.63 60.3 15.68"
  }), React.createElement("polygon", {
    points: "67.97 18.75 64.77 15.49 64.84 14.35 67.31 17.07 67.97 18.75"
  }), React.createElement("polygon", {
    points: "54.75 2.34 53.38 2.89 53.34 1.9 55.09 1.95 54.75 2.34"
  }), React.createElement("polygon", {
    points: "243.65 0 249.62 124.8 253.27 130.3 254.6 134.88 253.03 137.72 256 142.52 185.32 145.27 182.34 147.76 166.29 149.09 163.42 151.8 154.37 153.54 144.53 158.46 131.44 158.82 122.09 163.09 113.53 164.01 109.64 159.85 92.2 159.09 76.38 166.26 61.02 161.98 58.57 146.17 53.45 138.5 48.7 135.94 42.57 137 37.63 131.44 32.52 131.89 29.71 129.61 23.93 132.11 19.56 129.11 16.55 130.58 18.2 113.43 21 125.79 22.29 122.98 24.95 124.16 22.16 121.31 23.35 117.94 21.52 114.1 23.51 115.16 24.26 110.91 26.35 112.41 27.96 111.71 24.14 108.74 17.65 108.92 16.48 100.72 19.8 104.02 19.17 101.24 26.86 98.25 20.81 97.14 18.06 93.55 15 99.11 14.98 86.85 11.39 78.57 10.25 64.75 1.25 47.77 0 40.08 2.36 32.09 0.53 28.88 25.06 40.74 46.78 43.87 51.27 40.74 49.89 42.36 53.96 47.23 57.3 44.94 58.9 49.83 60.51 47.88 58.9 44.43 62.39 42.87 61.62 45.64 66.89 55.58 60.86 64.88 60.89 57.06 59.73 59.97 59.23 57.85 59.69 61.66 48.75 79.98 51.56 80.65 59.3 76.69 52.3 79.6 50.35 78.4 55.95 68.71 62.03 65.42 66.75 57.03 68.41 58.38 67.19 52.32 69.88 54.31 71.64 61.47 68.74 62.18 67.47 64.46 65.41 62.57 67.47 69.68 64.66 66.32 64.13 67.68 65.94 69.92 64.52 72.25 68.73 69.68 70.13 72.73 67.89 84.93 64.1 83.06 66.09 79.34 65.94 78.16 62.86 81.22 61.14 89.11 60.34 78.35 54.89 88.56 51.47 90.15 51.11 90.89 53.09 90.94 51.07 92.52 56.01 88.91 53.27 93.23 55.78 91.02 57.05 95.02 58.52 89.43 58.25 91.08 59.68 89.43 62.68 93.15 67.73 87.54 68.95 82.47 72.29 84.98 75.78 80.64 73.38 70.18 75.41 70.83 75.63 69.08 72.83 66.09 73.75 59.55 76.58 52.7 80.79 48.75 76.09 45.62 75.07 39.72 73.16 38.65 72.14 42.24 75.81 47.32 71.34 43.59 70.5 38.35 74.67 38.43 74.83 35.38 70.19 31.89 69.45 29.04 66.64 30.42 65.49 29.13 64.97 25.88 67.19 25.05 68.79 27.86 69.22 26.38 71.7 28.09 69.36 21.8 72.47 23.35 73.37 22.11 71.39 13.71 69.33 12.48 66.35 14.73 64.09 5.79 62.15 4.94 64.59 3.82 63.95 2.19 156.94 2.72 243.65 0"
  }));
});

var WI = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237.6 256"
  }, React.createElement("polygon", {
    points: "230.22 98.09 232.7 98.01 232.85 100.69 229.88 101 230.63 106.13 228.44 105.83 230.45 108.05 225.36 115.44 225.88 118.21 219.59 124.93 217.01 121.52 217.1 116.93 221.05 111.83 222.46 105.45 226.73 103.56 230.22 98.09"
  }), React.createElement("polygon", {
    points: "234.38 90.64 237.6 91.57 237.28 95.13 232.93 94.91 234.38 90.64"
  }), React.createElement("polygon", {
    points: "85.07 16.81 82.79 17.74 90.4 11.5 90.95 13.01 85.07 16.81"
  }), React.createElement("polygon", {
    points: "92.27 8.19 92.25 9.64 87.97 8.6 93.09 6.5 92.27 8.19"
  }), React.createElement("polygon", {
    points: "81.43 7.43 84.2 10.21 76.53 26.39 83.31 24.79 84.28 21.04 91.45 26.55 97.64 27.59 98.28 29.9 104.54 32.13 108.85 41.55 147.74 52.15 158.81 58.31 170.84 58.69 184.54 62.22 188.34 66.64 187.48 70.78 195.71 73.06 199.7 76.97 199.93 87.45 197.04 94.39 205.43 94.04 203.2 104.6 208.66 109.33 206.9 115.64 198.93 119.85 191.78 139.18 193.75 141.1 196.66 140.6 203.16 134.13 209.48 123.26 214.98 121.39 219.99 125.86 212.06 152.98 214.18 159.94 208.82 165.64 205.72 174.97 206.91 187.6 199.17 212.62 199.81 226.31 205.49 239.22 204.59 255.97 86.84 256 84.34 247.93 71.66 244.36 68.86 240.09 65.52 219.38 68.98 210.63 64.02 207.44 62.5 202.38 62.95 186.84 60.99 176.79 56.27 171.15 46.78 168.15 40.16 162.72 35.03 152.9 29.05 147.08 21.75 144.98 17.61 138.76 10.03 136.93 0.92 128.22 3.7 118.91 2.25 110.32 4.43 107.69 4.36 98.88 8.43 91.01 5.22 83.45 0.06 82.32 0 75.16 7.74 63.7 18.7 57.35 21.25 57.73 24.1 54.68 25.16 22.22 28.01 22.26 32.18 16.52 37.76 21.01 44.35 20.31 59.53 16.12 66.4 10.72 70.09 12.18 76.01 7.29 79.81 6.01 81.43 7.43"
  }), React.createElement("polygon", {
    points: "86.18 8.75 83.86 7.62 84.66 6.06 86.5 7.8 86.18 8.75"
  }), React.createElement("polygon", {
    points: "76.98 5.92 75.75 5.08 77.31 3.68 77.85 4.46 76.98 5.92"
  }), React.createElement("polygon", {
    points: "96.86 3.69 95.22 4.44 97.83 0 97.73 2.68 96.86 3.69"
  }));
});

var WV = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 228.25"
  }, React.createElement("polygon", {
    points: "165.84 61.92 165.42 96.22 175.53 89.64 185.19 78.83 188.02 77.8 192.68 79.67 200.36 72 201.84 67.43 203.96 69.16 203.31 71.29 206.81 73.43 217.86 74.15 219.69 72.26 218.56 70.63 221.05 70.09 219.6 68.1 227.52 67.25 232.37 62.59 243.57 69.26 249.85 68.47 250.38 70.5 248.18 71.68 249.3 74.89 250.37 73.06 251.35 76.09 253.93 75.72 252.15 79.33 255.21 80.94 256 87.06 251 99.6 225.51 79.57 221.15 91.75 220.67 99.21 212.44 110.45 207.66 114.76 204.06 114.5 197.65 123.99 190.8 120.43 175.98 148.17 164.31 144.65 162.23 139.04 156.91 137.44 149.22 158.35 142.78 164.64 138.33 176.44 127.32 188.81 123.13 197.41 126.26 201.68 121.92 205.49 122.52 209.13 114.07 214.36 110.09 211.73 98.55 217.35 93.16 214.41 91.12 220.97 72.83 226.09 66.2 219.89 54.87 228.25 49.73 227.73 40.36 222.17 32.9 210.23 34.34 206.05 25.95 203.69 16.88 195.44 7.37 178.23 8.09 175.29 0 163.56 3.34 157.36 2.81 145.9 16.36 144.73 19.51 135.18 24.77 133.77 23.48 122.13 31.73 107.89 34.65 106.74 37.99 108.91 39.65 116.71 43.81 111.47 46.91 112.7 44.33 103.13 47.69 101.52 47.85 96.7 51.7 90.58 56.96 90.41 58.44 85.86 63.25 81.81 65.44 81.88 68.05 85.61 75.44 82.6 93.85 67.57 95.98 61.5 94.21 58.09 98.12 51.66 97.9 47.9 100.13 47.64 101.47 37.62 108.56 21.5 107.17 17.29 108.63 11.64 105.45 2.44 112.9 0 112.25 61.64 165.84 61.92"
  }));
});

var WY = (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200.31"
  }, React.createElement("polygon", {
    points: "254.77 103.69 256 200.31 125.05 199.29 0 193.31 13.55 0 130.92 6.06 253.34 7.08 254.77 103.69"
  }));
});



var states = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AK: AK,
  AL: AL,
  AR: AR,
  AZ: AZ,
  CA: CA,
  CO: CO,
  CT: CT,
  DC: DC,
  DE: DE,
  FL: FL,
  GA: GA,
  HI: HI,
  IA: IA,
  ID: ID,
  IL: IL,
  IN: IN,
  KS: KS,
  KY: KY,
  LA: LA,
  MA: MA,
  MD: MD,
  ME: ME,
  MI: MI,
  MN: MN,
  MO: MO,
  MS: MS,
  MT: MT,
  NC: NC,
  ND: ND,
  NE: NE,
  NH: NH,
  NJ: NJ,
  NM: NM,
  NV: NV,
  NY: NY,
  OH: OH,
  OK: OK,
  OR: OR,
  PA: PA,
  PR: PR,
  RI: RI,
  SC: SC,
  SD: SD,
  TN: TN,
  TX: TX,
  UT: UT,
  VA: VA,
  VT: VT,
  WA: WA,
  WI: WI,
  WV: WV,
  WY: WY
});

var State = function State(props) {
  var lookupStr = props.children || props.state;

  if (!lookupStr) {
    return null;
  }

  var stateData = us.lookup(lookupStr);

  if (!stateData) {
    return null;
  }

  var postal = stateData.abbr;

  if (!(postal in states)) {
    return null;
  }

  var SVG = states[postal];
  return React.createElement("div", {
    className: classnames('react-stateface-container', "rsf-".concat(postal))
  }, React.createElement(SVG, null));
};

export default State;
